/* eslint-disable */
import { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { CButton, CCol, CRow, CFormGroup, CLabel, CSelect, CInput, CDropdown, CDropdownToggle, CDropdownMenu, CDropdownItem, CDropdownDivider, CTooltip, CModal, CModalHeader, CModalTitle, CModalFooter, CForm, CBadge, CSpinner } from '@coreui/react';
import 'react-circular-progressbar/dist/styles.css';
import './ProjectDetails.css';
import data from '../../json/dupa';
import NumberFormat from 'react-number-format';
import Loading from '../aimhi-widgets/Loading';
import $axios from 'src/utils/axios';
import { featuresFlags } from 'src/StoreGlobal/features';
import IP from '../../StoreGlobal/IP';
import CreatableSelect from 'react-select/creatable';
import { useSelector, useDispatch } from 'react-redux';
import BackupButton from '../aimhi-widgets/BackupButton';
import { showError } from 'src/utils/swalError';
import { FaRegQuestionCircle, FaPencilAlt, FaTrashAlt, FaArchive } from 'react-icons/fa';
import { useDialog } from 'src/utils/DialogContext';
import useSubscriptionCheck from 'src/utils/useSubscriptionCheck';
import PrintEstimate from './PrintEstimate';
import { GetEstimate, SearchSow, GetCompanyWorkItemDescription } from 'src/request/Estimate';
import { GetManpowerPosition, AddPosition } from 'src/request/Manpower';
import RiskCalculator from '../aimhi-widgets/RiskCalculator';
import debounce from 'lodash/debounce';
import AIButton from '../aimhi-widgets/AIButton';
import RecommenderPopUp from '../aimhi-widgets/RecommenderPopUp';
import { DownloadReport } from 'src/request/Projects';
import { findAllowedFeature } from 'src/utils/findAllowedFeature';
import { useLocation, useParams } from 'react-router-dom';
import { ceilToDecimalPlacesPayload } from 'src/utils/ceilToDecimalPlaces';
import { preventInvalidKeys, blurOnWheel, preventInvalidPaste } from 'src/reusable/inputSettings';
import EstimateUpload from '../estimate-importer/EstimateUpload';
import { triggerProjectRefetch } from 'src/store/feature/project/projectSlice';
import useCheckPermission from 'src/utils/useCheckPermission';
import ProjectTabs from '../projects/ProjectTabs';
import { trackEvent, mixPanelEvents } from 'src/utils/mixpanel';
const empty_format = {
  0: '',
  remove_sow: false,
  new: true,
  actual_cp: 0,
  actual_ocm: 0,
  actual_total_contract_cost: 0,
  actual_total_direct_cost: 0,
  actual_total_indirect_cost: 0,
  actual_vat: 0,
  cp_balance: 0,
  equipment: [],
  material: [],
  estimated_cp: 0,
  estimated_ocm: 0,
  estimated_total_contract_cost: 0,
  estimated_total_direct_cost: 0,
  estimated_total_indirect_cost: 0,
  estimated_vat: 0,
  id: 0,
  labor: [],
  ocm_balance: 0,
  phase: '',
  phase_id: 0,
  psow_id: -1,
  quantity: 0,
  sow_id: -1,
  total_actual_equipment_cost: 0,
  total_actual_equipment_cost_subcon: 0,
  total_actual_labor_cost_subcon: 0,
  total_actual_material_cost_subcon: 0,
  total_actual_labor_cost: 0,
  total_actual_material_cost: 0,
  total_contract_cost_balance: 0,
  total_direct_cost_balance: 0,
  total_equipment_balance: 0,
  total_estimated_equipment_cost: 0,
  total_estimated_labor_cost: 0,
  total_estimated_material_cost: 0,
  total_indirect_cost_balance: 0,
  total_labor_balance: 0,
  total_material_balance: 0,
  vat_balance: 0,
  edit: false,
  area_or_volume: 0,
  area_or_volume_unit: 'sq.m',
  is_sub_con: 0,
  measurement: 0,
  unit_id: 7,
  isEmptyWork: true,
  isEmptyPhase: true,
  isEmptyMeasurement: true,
};

const empty_labor = {
  designation: '',
  estimated_workers: 0,
  hired_workers: 0,
  duration: '0 days',
  rate: 0,
  estimated_cost: 0,
  actual_cost: 0,
  balance: 0,
  id: 0,
  labor_id: -1,
  edit: true,
  new: true,
  is_sub_con: false,
  is_variance_order: false,
  calculator: 0,
};

const empty_equipment = {
  description: '',
  estimated_quantity: 0,
  ordered_quantity: 0,
  duration: '0 days',
  rate: 0,
  estimated_cost: 0,
  actual_cost: 0,
  balance: 0,
  id: 0,
  equipment_category_id: -1,
  edit: true,
  new: true,
  is_sub_con: false,
  is_variance_order: false,
  calculator: 0,
};

const empty_material = {
  description: '',
  estimated_quantity: 0,
  ordered_quantity: 0,
  unit: '',
  unit_cost: 0,
  estimated_cost: 0.0,
  actual_cost: 0,
  balance: 0,
  id: 0,
  material_id: -1,
  edit: true,
  new: true,
  is_sub_con: false,
  is_variance_order: false,
  calculator: 0,
  recommendations: {},
};

// variables used for setTimeout for debounce
let quantityTimer = null;
let unitCostTimer = null;


const ComponentUseCase2 = (props) => {
  const [selectedOption, setSelectedOption] = useState(null);

  const recommendations = [
    {
      title: props.recommendations.title,
      options: [...props.recommendations.options, { text: 'Use Current Unit Cost', price: props.recommendations.original_price }],
    },
  ];

  const handleOptionChange = (value) => {
    setSelectedOption(value);
  };

  const handleSubmit = () => {
    props.unitCostOnChange(recommendations[0]?.options[selectedOption]?.price, props.scopeIndex, props.Index, false);
    props.handleSubmit();
    props.handleClose();
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
      }}
    >
      {recommendations.map((recommendation, index) => (
        <div key={index}>
          <p style={{ fontSize: '12px', marginBottom: '10px', textAlign: 'center' }}>{recommendation.title}</p>
          <ul style={{ listStyleType: 'none', padding: 0 }}>
            {recommendation.options.map((option, optionIndex) => (
              <li key={optionIndex} style={{ marginBottom: '10px' }}>
                <label style={{ display: 'flex', alignItems: 'center' }}>
                  <input type="radio" name={`recommendation-${index}`} value={`option-${optionIndex + 1}`} checked={selectedOption === optionIndex} onChange={() => handleOptionChange(optionIndex)} />
                  <span style={{ marginLeft: '5px' }}>{option.text}</span>
                </label>
              </li>
            ))}
          </ul>
        </div>
      ))}
      <div>
        <CButton disabled={selectedOption === null} className="ml-auto" onClick={handleSubmit} style={{ backgroundColor: '#23303D', color: '#FFFFFF', marginRight: '10px', fontSize: '12px', marginBottom: '10px' }}>
          Apply
        </CButton>
      </div>
    </div>
  );
};

const ProjectBudgetDetail = (props) => {
  const { id } = useParams();
  const projectID = parseInt(id);
  const Swal = require('sweetalert2');
  const dispatch = useDispatch();
  const features = useSelector((state) => state.ui.features);
  const company_id = parseInt(localStorage.getItem('company_id'));
  let accessToken = localStorage.getItem('token');
  let user_id = parseInt(localStorage.getItem('user_id'));
  const { openDialog, closeDialog } = useDialog();
  const { refreshSubscription, handleSubscriptionRequest, NoCreditsLeft } = useSubscriptionCheck();
  const projectInfo = useSelector((state) => state.project.projectInfo[projectID]);
  let completeWorkItemList = null; // will have value when all work items are fetched from backend

  const [dupadata, setdupadata] = useState([]);
  const [backupData, setbackupData] = useState([]);
  const [isEdit, setisEdit] = useState(false);
  const [inputclass, setinputclass] = useState('input_outline');
  const [inputdisable, setinputdisable] = useState(true);
  const [buttonName, setbuttonName] = useState('Edit');
  const [togglescope, settogglescope] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show, setshow] = useState(true);
  const [grantTotal, setgrantTotal] = useState({});
  const [errorhandling, seterrorHandling] = useState(true);
  const [sowOptions, setSowOption] = useState({});
  const [sowSearchOptions, setSowSearchOptions] = useState([]);
  const [listLabor, setlistLabor] = useState([]);
  const [listEquipment, setlistEquipment] = useState([]);
  const [listMaterial, setlistMaterial] = useState([]);
  const [laborValue, setlaborValue] = useState([]);
  const [butttonTransition, setbuttonTransition] = useState(false);
  const [newId, setnewId] = useState(0);
  const [phssenewId, setphasenewId] = useState(0);
  const [estimateStatus, setestimateStatus] = useState(1);
  const [printEstimate, setPrintEstimate] = useState(false);
  const [hasVAT, setHasVAT] = useState(0);
  const [phases, setPhases] = useState([]);
  const [editSow, setEditSow] = useState([]);
  const [dateUpdated, setDateUpdated] = useState('');
  const [updatedBy, setUpdatedBy] = useState('');
  const [search, setSearch] = useState('');
  const isApprover = useSelector((state) => state.auth.userRole.approver);
  const [showOptions, setShowOptions] = useState([]);
  const [isCalculatorOpen, setCalculatorOpen] = useState(false); //state to open calculator
  const [calculatorSow, setCalculatorSow] = useState(''); //state for Sow calculator
  const [calculatorTitle, setCalculatorTitle] = useState(''); //state for calculator title
  const [calculatorWorkItem, setCalculatorWorkItem] = useState(''); //state for calculator work item
  const [dataAvailable, setDataAvailable] = useState(false); //state for dataAvailable
  const [sowIndex, setSowIndex] = useState(0);
  const [index, setIndex] = useState(0);
  const [materialName, setMaterialName] = useState('');
  const [laborProductivity, setLaborProductivity] = useState([]);
  const [equipmentProductivity, setEquipmentProductivity] = useState([]);
  const [materialQuantity, setMaterialQuantity] = useState([]);
  const [isSowAdded, setIsSowAdded] = useState(false);
  const [modalVarianceOrder, setModalVarianceOrder] = useState(false);
  const [varianceOrderData, setVarianceOrderData] = useState([]);
  const [showRecommender2, setShowRecommender2] = useState(false);
  const [showRecommender3, setShowRecommender3] = useState(false);
  const [activeRecommenderIndex2, setActiveRecommenderIndex2] = useState({});
  const [activeRecommenderIndex3, setActiveRecommenderIndex3] = useState({});
  const [modalCategory, setModalCategory] = useState(false);
  const [equipmentName, setEquipmentName] = useState('');
  const [category, setCategory] = useState('');
  const [units, setUnits] = useState({});
  const [position, setPosition] = useState('');
  const [positionDescription, setPositionDescription] = useState('');
  const [modalPosition, setModalPosition] = useState(false);
  const [laborID, setLaborID] = useState(999);
  const [equipmentID, setEquipmentID] = useState(999);
  const [materialID, setMaterialID] = useState(999);
  const [isLoading, setIsLoading] = useState(false);
  const [isDownloadableReportAllowed, setIsDownloadableReportAllowed] = useState(false);
  const [isEstimateRecoToolAllowed, setIsEstimateRecoToolAllowed] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [isLaborGrantTotalEditing, setLaborGrantTotalEditing] = useState(false);
  const [isEquipmentGrantTotalEditing, setEquipmentGrantTotalEditing] = useState(false);
  const [editableGrantTotal, setEditableGrantTotal] = useState();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const sow_id = queryParams.get('sow_id');
  const psow_id = queryParams.get('psow_id');
  const [isTotalActualCostEdited, setIsTotalActualCostEdited] = useState(false);
  const [workItemDescriptionList, setWorkItemDescriptionList] = useState([]);
  const [showEstimateUpload, setShowEstimateUpload] = useState(false);
  const checkPermission = useCheckPermission();

  useEffect(() => {
    getdetailed(projectID);
    getmanpower(projectID);
    getequipment(projectID);
    getmaterial(projectID);
    getWorkItemDescription(projectID);
    // update sowOptions -- get all scope of work
    if (!(-1 in sowOptions)) {
      getsowlist(projectID, ['UPDATE_SOW_OPTION'], null);
    }

    setestimateStatus(projectInfo?.estimate_status);
    getStandardPhases();
    getUnits();
    start();
  }, []);

  useEffect(() => {
    if (features.length > 0) {
      setIsDownloadableReportAllowed(findAllowedFeature(features, 5));
      setIsEstimateRecoToolAllowed(findAllowedFeature(features, 6));
    }
  }, [features]);

  const getWorkItemDescription = (project_id) => {
    GetCompanyWorkItemDescription(project_id).then((response) => {
      const transformedData = response?.data.map((item) => ({
        value: item.company_tag_id,
        label: item.tag_name
      }))
      setWorkItemDescriptionList(transformedData);
    })
  }

  // if laborProductivity is updated setDataAvailable to true to show the AIButton.
  useEffect(() => {
    if (laborProductivity && laborProductivity.length > 0 && laborProductivity[0].productivity !== null) {
      setLaborProductivityAvailable({ scopeIndex: sowIndex, Index: index, fromToggle: 0 });
    }
  }, [laborProductivity]);

  useEffect(() => {
    if (equipmentProductivity && equipmentProductivity.length > 0 && equipmentProductivity[0].productivity !== null) {
      setEquipmentProductivityAvailable({ scopeIndex: sowIndex, Index: index, fromToggle: 0 });
    }
  }, [equipmentProductivity]);

  useEffect(() => {
    if (materialQuantity && materialQuantity.length > 0) {
      setMaterialQuantityAvailable({ scopeIndex: sowIndex, Index: index, fromToggle: 0 });
    }
  }, [materialQuantity]);

  useEffect(() => {
    let activeIndex2 = { ...activeRecommenderIndex2 };
    let activeIndex3 = { ...activeRecommenderIndex3 };

    for (let i = 0; i < dupadata.length; i++) {
      for (let j = 0; j < dupadata[i].material.length; j++) {
        let has_price_rec = dupadata[i].material[j].has_price_rec;
        let has_quantity_rec = dupadata[i].material[j].has_quantity_rec;
        let recommendations = dupadata[i].material[j].recommendations;

        // Use Case #2
        if (!(i in activeIndex2)) {
          activeIndex2[i] = {};
        }

        if (!(j in activeIndex2[i])) {
          activeIndex2[i][j] = {
            isOpen: has_price_rec == 1,
            isLoading: has_price_rec == 1 && !('price' in recommendations),
          };

          if ('price' in recommendations) {
            activeIndex2[i][j] = { ...activeIndex2[i][j], ...recommendations.price };
          }
        }

        // Use Case #3
        if (!(i in activeIndex3)) {
          activeIndex3[i] = {};
        }

        if (!(j in activeIndex3[i])) {
          activeIndex3[i][j] = {
            isOpen: has_quantity_rec == 1,
            isLoading: has_quantity_rec == 1 && !('quantity' in recommendations),
          };

          if ('quantity' in recommendations) {
            activeIndex3[i][j] = { ...activeIndex3[i][j], ...recommendations.quantity };
          }
        }
      }
    }

    // initialize value
    setActiveRecommenderIndex2(activeIndex2);
    setActiveRecommenderIndex3(activeIndex3);
  }, [dupadata]);

  useEffect(() => {
    if (sow_id && psow_id) {
      const identifier = `#sow_id-${sow_id}-psow_id-${psow_id}`;
      scrollToElement(identifier);
    }
  }, [sow_id, psow_id, dupadata]);

  const setLaborProductivityAvailable = ({ scopeIndex, Index, fromToggle, noData }) => {
    let newArr = [...dupadata];

    if (newArr[scopeIndex] && newArr[scopeIndex].labor) {
      if (fromToggle === 1 || laborProductivity[0]?.from_backup === 1) {
        newArr[scopeIndex].labor[Index].dataAvailable = null;
        if (noData !== 1) {
          newArr[scopeIndex].labor[Index].show_calculator = 0;
        }
      } else if (fromToggle === 0) {
        newArr[scopeIndex].labor[Index].dataAvailable = true;
      } else {
        console.error('error undefined');
      }
    }

    setdupadata(newArr);
  };

  const setEquipmentProductivityAvailable = ({ scopeIndex, Index, fromToggle }) => {
    let newArr = [...dupadata];

    if (newArr[scopeIndex] && newArr[scopeIndex].equipment) {
      if (fromToggle === 1 || equipmentProductivity[0]?.from_backup) {
        newArr[scopeIndex].equipment[Index].dataAvailable = null;
        newArr[scopeIndex].equipment[Index].show_calculator = 0;
      } else if (fromToggle === 0) {
        newArr[scopeIndex].equipment[Index].dataAvailable = true;
      } else {
        console.error('error undefined');
      }
    }

    setdupadata(newArr);
  };

  const setMaterialQuantityAvailable = ({ scopeIndex, Index, fromToggle, noData }) => {
    let newArr = [...dupadata];
    if (newArr[scopeIndex] && newArr[scopeIndex].material) {
      if (fromToggle === 1 || materialQuantity[0]?.from_backup || noData === 1) {
        if (newArr[scopeIndex].material[Index]) {
          newArr[scopeIndex].material[Index].dataAvailable = null;
        }
      } else if (fromToggle === 0) {
        if (newArr[scopeIndex].material[Index]) {
          newArr[scopeIndex].material[Index].dataAvailable = true;
        }
      } else {
        console.error('error undefined');
      }
    }

    setdupadata(newArr);
  };

  const toggleCalculator = async (props) => {
    const { balance, status } = await refreshSubscription();
    if (props.isClosed) {
      setCalculatorOpen(false);
    } else if (props.isApply) {
      setCalculatorOpen(false);

      if (calculatorTitle === 'Labor') {
        setLaborProductivityAvailable({ scopeIndex: sowIndex, Index: index, fromToggle: 1 });
      } else if (calculatorTitle === 'Equipment') {
        setEquipmentProductivityAvailable({ scopeIndex: sowIndex, Index: index, fromToggle: 1 });
      } else if (calculatorTitle === 'Material') {
        setMaterialQuantityAvailable({ scopeIndex: sowIndex, Index: index, fromToggle: 1 });
      }
    } else {
      const proceedCalculator = () => {
        trackEvent(mixPanelEvents.USE_CALCULATOR, {
          'Source': 'Project - Estimate',
          'Calculator Type': calculatorTitle,
        });
        closeDialog();
        setSowIndex(props.scopeIndex);
        setIndex(props.Index);
        if (props.title) {
          setCalculatorTitle(props.title);
          setCalculatorSow(dupadata[props.scopeIndex]?.phase);
          setCalculatorWorkItem(dupadata[props.scopeIndex][0]);
        } else {
          setCalculatorTitle(props.history_title ? props.history_title : calculatorTitle);
          setCalculatorSow(dupadata[props.scopeIndex]?.phase);
          setCalculatorWorkItem(dupadata[props.scopeIndex][0]);
        }
        setCalculatorOpen(true);
      }

      if (status === 0) {
        if (balance != null && +balance < 15) return NoCreditsLeft();
        openDialog({
          title: 'Power Tool Feature',
          message: `You have ${balance} credits. Get unlimited Power Tools for P250/month or pay P15 per use. Once you use your credits, there’s no going back—no refunds or changes. Are you sure you want to continue? If so, how would you like to proceed?`,
          onPrimaryAction: proceedCalculator,
          primaryActionText: 'Pay P15',
          onSecondaryAction: () => handleSubscriptionRequest().then((res) => res === 1 && proceedCalculator()),
          secondaryActionText: 'Subscribe for P250',
          iconType: 'info',
          iconColor: '#3B74BE',
        });
      }
      else {
        proceedCalculator()
      }
    }
  };

  const updateIsSowAdded = (value) => {
    setIsSowAdded(value);
  };

  const toggleRecommenderPopUp = (component_id, value = null) => {
    if (component_id === 2) {
      setShowRecommender2(value ? value : !showRecommender2);
    } else if (component_id === 3) {
      setShowRecommender3(value ? value : !showRecommender3);
    }
  };

  const hideRecommenderPopup = (scopeIndex, Index, type) => {
    let activeIndex = null;
    let modifier = null;

    if (type == 'price') {
      activeIndex = { ...activeRecommenderIndex2 };
      modifier = setActiveRecommenderIndex2;
    } else {
      activeIndex = { ...activeRecommenderIndex3 };
      modifier = setActiveRecommenderIndex3;
    }

    if (Object.keys(activeIndex[scopeIndex]).length > 1) {
      delete activeIndex[scopeIndex][Index];
    } else {
      delete activeIndex[scopeIndex];
    }

    modifier(activeIndex);
  };
  const updateSowList = (phaseId) => {
    if (!(phaseId in sowOptions)) {
      getsowlist(projectID, ['UPDATE_SOW_OPTION'], phaseId);
    }
  };

  const AddSow = () => {
    let newarray = [...sortedData];
    let newdata = { ...structuredClone(empty_format), isNew: true };
    newarray.unshift(newdata);
    if (!(-1 in sowOptions)) {
      getsowlist(projectID, ['UPDATE_SOW_OPTION'], null);
    }
    setdupadata(newarray);
    setbuttonTransition(true);
    setIsSowAdded(true);
  };

  const EditSow = (id) => {
    let arr = [...sortedData];

    let Index = arr.findIndex((a) => a.id == id);
    arr[Index]['edit'] = true;
    arr[Index].edit = true;

    updateSowList(arr[Index].phase_category_id);
    setdupadata(arr);
  };

  const RemoveSow = (id) => {
    Swal.fire({
      icon: 'question',
      title: 'Are you sure?',
      text: 'You want to remove this scope of work!',
      showCancelButton: true,
      confirmButtonColor: '#23303D',
      cancelButtonColor: '#B42A19',
      confirmButtonText: 'Remove',
    }).then((result) => {
      if (result.isConfirmed) {
        let arr = [...dupadata];

        let Index = arr.findIndex((a) => a.id == id);
        arr[Index]['remove_sow'] = true;

        setdupadata(arr);
      } else if (result.isDenied) {
      }
    });
  };
  const AddNew = (Index, data) => {
    let newarr = [...sortedData];

    if (data == 'Labor') {
      let newlabor = JSON.stringify(empty_labor);
      newarr[Index].labor.push(JSON.parse(newlabor));
      newarr[Index].title = 'Labor';
      setCalculatorTitle('Labor');
    } else if (data == 'Equipment') {
      let newEquipment = JSON.stringify(empty_equipment);
      newarr[Index].equipment.push(JSON.parse(newEquipment));
      newarr[Index].title = 'Equipment';
      setCalculatorTitle('Equipment');
    } else if (data == 'Material') {
      let newMaterial = JSON.stringify(empty_material);
      newarr[Index].material.push(JSON.parse(newMaterial));
      newarr[Index].title = 'Material';
      setCalculatorTitle('Material');
    }
    setdupadata(newarr);
    setCalculatorSow(newarr[Index].phase);
    setCalculatorWorkItem(newarr[Index][0]);
    newarr = [];

  };

  const workItemDescriptionChange = (opt, scopeIndex) => {
    let newDupaData = [...sortedData];
    newDupaData[scopeIndex].company_tag_id = opt ? opt.value : null,
      newDupaData[scopeIndex].tag_name = opt ? opt.label : '',
      setdupadata(newDupaData);
  }

  const handleCreateWorkItemDescription = (newValue, scopeIndex) => {
    const transformedData = {
      value: -1,
      label: newValue,
    }
    setWorkItemDescriptionList((prevData) => ([...prevData, transformedData]))
    workItemDescriptionChange(transformedData, scopeIndex);
  }

  const sowonchange = (opt, meta, scopeIndex) => {
    let newdata = [...sortedData];

    if (opt) {
      newdata[scopeIndex][0] = opt.label;
      newdata[scopeIndex].sow_id = opt.value;
      newdata[scopeIndex].isEmptyWork = false;

      const findPhase = phases.find((phase) => phase.value == opt.phase_id);

      newdata[scopeIndex]['phase'] = findPhase?.label || '';
      newdata[scopeIndex]['phase_id'] = opt.phase_id || null;
      newdata[scopeIndex].isEmptyPhase = false;
    } else {
      newdata[scopeIndex][0] = '';
      newdata[scopeIndex].sow_id = -1;
      newdata[scopeIndex].isEmptyWork = true;

      newdata[scopeIndex]['phase'] = '';
      newdata[scopeIndex]['phase_id'] = null;
      newdata[scopeIndex].isEmptyPhase = true;
    }

    setdupadata(newdata);
  };



  const phaseonchange = (opt, menubar, scopeIndex) => {
    let newdata = [...dupadata];
    if (opt) {

      newdata[scopeIndex]['phase'] = opt.label;
      newdata[scopeIndex]['phase_id'] = opt.value;
      newdata[scopeIndex]['phase_category_id'] = opt.phase_category_id;
      newdata[scopeIndex].isEmptyPhase = false;

      updateSowList(opt.phase_category_id);
    } else {
      newdata[scopeIndex]['phase'] = '';
      newdata[scopeIndex]['phase_id'] = null;
      newdata[scopeIndex]['phase_category_id'] = null;
      newdata[scopeIndex].isEmptyPhase = true;
    }

    // same process as sowonchange
    newdata[scopeIndex][0] = ''; // set work item description to empty
    newdata[scopeIndex].sow_id = -1; // set work item id to -1 (empty default)
    newdata[scopeIndex].isEmptyWork = true;

    setdupadata(newdata);
  };


  const LaborTotalOnchange = (e, Index) => {
    let newdata = [...sortedData];

    newdata[Index]['total_actual_labor_cost_subcon'] = parseFloat(e.target.value);
    setdupadata(newdata);
  };

  const EquipmentTotalChange = (e, Index) => {
    let newdata = [...sortedData];

    newdata[Index]['total_actual_equipment_cost_subcon'] = parseFloat(e.target.value);

    setdupadata(newdata);
  };

  const setLaborProductivityForCalculator = (laborProductivityArray) => {
    setLaborProductivity(laborProductivityArray);
  };

  const setEquipmentProductivityForCalculator = (equipmentProductivityArray) => {
    setEquipmentProductivity(equipmentProductivityArray);
  };

  const setMaterialQuantityForCalculator = (materialQuantityArray) => {
    setMaterialQuantity(materialQuantityArray);
  };

  const LaborOnchange = (opt, meta, scopeIndex, Index) => {
    let newdata = [...dupadata];
    let laborId = laborID;
    let area_value = newdata[scopeIndex].measurement;
    newdata[scopeIndex].labor[Index].designation = opt.label;
    newdata[scopeIndex].labor[Index].labor_id = opt.value;
    newdata[scopeIndex].labor[Index].calculator = 0;
    newdata[scopeIndex].labor[Index].id !== 0 ? (newdata[scopeIndex].labor[Index].id = newdata[scopeIndex].labor[Index].id) : (newdata[scopeIndex].labor[Index].id = laborId);
    newdata[scopeIndex]['edit'] = true;
    if (opt.label && opt.value) {
      newdata[scopeIndex].labor[Index].isEmpty = false;
    }
    if (newdata[scopeIndex].is_sub_con === 1) {
      newdata[scopeIndex].labor[Index].is_sub_con = true;
    } else {
      newdata[scopeIndex].labor[Index].is_sub_con = false;
    }
    setdupadata(newdata);
    setLaborID(laborId++);

    const requestData = {
      type: 1,
      phase_id: newdata[scopeIndex].phase_id,
      sow_id: newdata[scopeIndex].sow_id,
      project_id: projectID,
      type_id: opt.value,
      unit_area_id: newdata[scopeIndex].unit_id < 0 ? 7 : newdata[scopeIndex].unit_id,
    };

    if (isEstimateRecoToolAllowed) {
      newdata[scopeIndex].labor[Index].show_calculator = 1;
      $axios
        .post(IP + 'calculator/detail', requestData, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          if (response.data.response == 'No data') {
            let area_unit_id = newdata[scopeIndex].unit_id < 0 ? 7 : newdata[scopeIndex].unit_id;
            let productivity_history = response.data.history;
            setLaborProductivityAvailable({ scopeIndex: scopeIndex, Index: Index, noData: 1 });
            toggleCalculator({ isClosed: true });
            let laborProductivityArray = [
              {
                productivity: productivity_history.length > 0 ? productivity_history[0] : null,
                productivity_unit: null,
                area_value: area_value,
                area_unit: null,
                area_unit_id: area_unit_id || 7,
                time_unit: null,
                time_unit_id: null,
                phase_id: newdata[scopeIndex].phase_id,
                sow_id: newdata[scopeIndex].sow_id,
                type_id: opt?.value,
                no_productivity: 1,
                productivity_history: productivity_history,
              },
            ];
            setLaborProductivity(laborProductivityArray);
          } else {
            let productivity = response.data.response.productivity;
            let productivity_unit = `${response.data.response.unit_area_abbreviation} / ${response.data.response.unit_time_abbreviation === 'h' ? 'hr' : 'day'}`;
            let area_unit = response.data.response.unit_area_abbreviation;
            let area_unit_id = response.data.response.unit_area_id;
            let time_unit = response.data.response.unit_time_abbreviation;
            let time_unit_id = response.data.response.unit_time_id;
            let productivity_history = response.data.response.history;
            let laborProductivityArray = [
              {
                productivity: productivity,
                productivity_unit: productivity_unit,
                area_value: area_value,
                area_unit: area_unit,
                area_unit_id: area_unit_id,
                time_unit: time_unit,
                time_unit_id: time_unit_id,
                phase_id: newdata[scopeIndex].phase_id,
                sow_id: newdata[scopeIndex].sow_id,
                type_id: opt.value,
                productivity_history: productivity_history,
              },
            ];

            setLaborProductivityForCalculator(laborProductivityArray);
          }
        })
        .catch((error) => {
          if (error?.response?.status === 403) {
            showError(error?.response?.data?.response, "Permission Denied");
            return;
          }
          // Handle errors
          console.error('Error making request:', error);
        });
    }


    setIndex(Index);
    setSowIndex(scopeIndex);

  };

  const createOption = (opt, meta, scopeIndex, Index) => {
    let newarr = [...listLabor];
    let a = newId;
    newarr.push({
      value: a--,
      label: opt,
    });

    setlistLabor(newarr);

    let newdata = [...dupadata];
    newdata[scopeIndex].labor[Index].designation = opt;
    newdata[scopeIndex].labor[Index].labor_id = a--;
    newdata[scopeIndex]['edit'] = true;
    if (opt) {
      newdata[scopeIndex].labor[Index].isEmpty = false;
    }
    setnewId(a--);
    setdupadata(newdata);
    setPosition(opt);
    setModalPosition(!modalPosition);
  };

  const durationOnchange = (val, scopeIndex, Index, fromCalculator) => {
    if (fromCalculator === 1) {
      let newArr = [...dupadata];
      newArr[scopeIndex].labor[Index].duration = val;
      newArr[scopeIndex]['edit'] = true;

      setdupadata(newArr);
    } else {
      let newArr = [...dupadata];
      newArr[scopeIndex].labor[Index].duration = val ? val : 0;
      newArr[scopeIndex].labor[Index].calculator = 0;
      newArr[scopeIndex]['edit'] = true;

      setdupadata(newArr);
    }
  };

  const LaborHiredWorkers = (val, scopeIndex, Index) => {
    let newArr = [...dupadata];
    newArr[scopeIndex].labor[Index].hired_workers = val ? parseInt(val) : 0;
    newArr[scopeIndex]['edit'] = true;

    setdupadata(newArr);
  };


  const EquipmentHiredWorkers = (val, scopeIndex, Index) => {
    let newArr = [...dupadata];
    newArr[scopeIndex].equipment[Index].ordered_quantity = val ? parseFloat(val) : 0;
    newArr[scopeIndex]['edit'] = true;

    setdupadata(newArr);
  };


  const MaterialHiredWorkers = (val, scopeIndex, Index) => {
    let newArr = [...dupadata];
    newArr[scopeIndex].material[Index].ordered_quantity = val ? parseFloat(val) : 0;
    newArr[scopeIndex]['edit'] = true;

    setdupadata(newArr);
  };

  const EquipmentCalculatorDetail = (scopeIndex, opt) => {
    const newarr = [...dupadata];
    let area_value = newarr[scopeIndex].measurement;
    let area_unit_id = newarr[scopeIndex].unit_id < 0 ? 7 : newarr[scopeIndex].unit_id;
    const requestData = {
      type: 2,
      phase_id: newarr[scopeIndex].phase_id,
      sow_id: newarr[scopeIndex].sow_id,
      project_id: projectID,
      type_id: opt?.value,
      unit_area_id: newarr[scopeIndex].unit_id,
    };

    $axios
      .post(IP + 'calculator/detail', requestData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        if (response.data.response == 'No data') {
          let productivity_history = response.data.history;
          setEquipmentProductivityAvailable({ scopeIndex: sowIndex, Index: index, noData: 1 });
          toggleCalculator({ isClosed: true });
          let equipmentProductivityArray = [
            {
              productivity: productivity_history?.length > 0 ? productivity_history[0] : null,
              productivity_unit: null,
              area_value: area_value,
              area_unit: null,
              area_unit_id: area_unit_id,
              time_unit: null,
              time_unit_id: null,
              phase_id: newarr[scopeIndex].phase_id,
              sow_id: newarr[scopeIndex].sow_id,
              type_id: opt?.value,
              no_productivity: 1,
              productivity_history: productivity_history,
            },
          ];
          setEquipmentProductivity(equipmentProductivityArray);
        } else {
          let productivity = response.data.response.productivity;
          let productivity_unit = `${response.data.response.unit_area_abbreviation} / ${response.data.response.unit_time_abbreviation === 'h' ? 'hr' : 'day'}`;
          let area_unit = response.data.response.unit_area_abbreviation;
          let area_unit_id = response.data.response.unit_area_id;
          let time_unit = response.data.response.unit_time_abbreviation;
          let time_unit_id = response.data.response.unit_time_id;
          let productivity_history = response.data.response.history;
          let equipmentProductivityArray = [
            {
              productivity: productivity,
              productivity_unit: productivity_unit,
              area_value: area_value,
              area_unit: area_unit,
              area_unit_id: area_unit_id,
              time_unit: time_unit,
              time_unit_id: time_unit_id,
              phase_id: newarr[scopeIndex].phase_id,
              sow_id: newarr[scopeIndex].sow_id,
              type_id: opt?.value,
              productivity_history: productivity_history,
            },
          ];

          setEquipmentProductivity(equipmentProductivityArray);
        }
      })
      .catch((error) => {
        if (error?.response?.status === 403) {
          showError(error?.response?.data?.response, "Permission Denied");
          return;
        }
        // Handle errors
        console.error('Error making request:', error);
      });
  };

  const EquipmentOnchange = (opt, meta, scopeIndex, Index) => {
    const newarr = [...dupadata];
    let equipmentId = equipmentID;

    newarr[scopeIndex].equipment[Index].description = opt.label;
    newarr[scopeIndex].equipment[Index].equipment_category_id = opt.value;
    newarr[scopeIndex].equipment[Index].calculator = 0;
    newarr[scopeIndex].equipment[Index].id !== 0 ? (newarr[scopeIndex].equipment[Index].id = newarr[scopeIndex].equipment[Index].id) : (newarr[scopeIndex].equipment[Index].id = equipmentId);
    newarr[scopeIndex]['edit'] = true;
    if (opt.label && opt.value) {
      newarr[scopeIndex].equipment[Index].isEmpty = false;
    }

    if (newarr[scopeIndex].is_sub_con === 1) {
      newarr[scopeIndex].equipment[Index].is_sub_con = true;
    } else {
      newarr[scopeIndex].equipment[Index].is_sub_con = false;
    }

    setdupadata(newarr);
    setEquipmentID(equipmentId++);

    if (isEstimateRecoToolAllowed) {
      newarr[scopeIndex].equipment[Index].show_calculator = 1;
      EquipmentCalculatorDetail(scopeIndex, opt);
    }

    setIndex(Index);
    setSowIndex(scopeIndex);
  };

  const showEquipmentModal = (e, scopeIndex, Index) => {
    let newarr = [...listEquipment];
    let a = newId;
    newarr.push({
      value: a--,
      label: e,
    });

    let newdata = [...dupadata];
    newdata[scopeIndex].equipment[Index].description = e;
    newdata[scopeIndex].equipment[Index].equipment_category_id = a--;
    newdata[scopeIndex]['edit'] = true;
    setnewId(a--);

    setdupadata(newdata);

    setCategory(e);
    setIndex(Index);
    setSowIndex(scopeIndex);
    setModalCategory(!modalCategory);
  };


  const qtyonchange = (val, scopeIndex, Index) => {
    let newArr = [...dupadata];
    newArr[scopeIndex].equipment[Index].estimated_quantity = val ? parseInt(val) : 0;
    newArr[scopeIndex]['edit'] = true;
    setdupadata(newArr);
  };

  const eqdurationonchange = (val, scopeIndex, Index) => {
    let newArr = [...dupadata];
    newArr[scopeIndex].equipment[Index].duration = val ? val : 0;
    newArr[scopeIndex]['edit'] = true;
    setdupadata(newArr);
  };

  const eqrateonchange = (val, scopeIndex, Index) => {
    let newArr = [...dupadata];
    newArr[scopeIndex].equipment[Index].rate = val ? parseFloat(val) : 0;
    newArr[scopeIndex]['edit'] = true;
    setdupadata(newArr);
  };

  const MaterialOnchange = (opt, meta, scopeIndex, Index) => {
    const newarr = [...dupadata];
    let materialId = materialID;
    let area_value = newarr[scopeIndex].measurement;

    newarr[scopeIndex].material[Index].description = opt.label;
    newarr[scopeIndex].material[Index].material_id = opt.value;
    newarr[scopeIndex].material[Index].calculator = 0;
    newarr[scopeIndex].material[Index].id !== 0 ? (newarr[scopeIndex].material[Index].id = newarr[scopeIndex].material[Index].id) : (newarr[scopeIndex].material[Index].id = materialId);
    newarr[scopeIndex]['edit'] = true;
    newarr[scopeIndex].material[Index].has_price_rec = null;
    newarr[scopeIndex].material[Index].has_quantity_rec = null;
    newarr[scopeIndex].material[Index].recommendations = {};

    if (opt.label && opt.value) {
      newarr[scopeIndex].material[Index].isEmpty = false;
    }

    if (newarr[scopeIndex].is_sub_con === 1) {
      newarr[scopeIndex].material[Index].is_sub_con = true;
    } else {
      newarr[scopeIndex].material[Index].is_sub_con = false;
    }

    const requestData = {
      type: 3,
      phase_id: newarr[scopeIndex].phase_id,
      sow_id: newarr[scopeIndex].sow_id,
      project_id: projectID,
      type_id: newarr[scopeIndex].material[Index].material_id,
    };

    if (isEstimateRecoToolAllowed) {
      $axios
        .post(IP + 'calculator/detail', requestData, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          if (response.data.response == 'No data') {
            setMaterialQuantityAvailable({ scopeIndex: scopeIndex, Index: Index, noData: 1 });
            toggleCalculator({ isClosed: true });
          } else {
            let data = [response.data.data];
            let input = [response.data.input];

            if (newarr[scopeIndex]?.measurement !== 0) {
              data.forEach((item) => {
                item.unit_area_value = newarr[scopeIndex]?.measurement;
              });
            }
            let materialArray = [{ data: data, input: input, type_id: newarr[scopeIndex].material[Index].material_id, phase_id: newarr[scopeIndex].phase_id, sow_id: newarr[scopeIndex].sow_id, area_value: area_value }];
            setMaterialQuantityForCalculator(materialArray);
          }
        })
        .catch((error) => {
          if (error?.response?.status === 403) {
            showError(error?.response?.data?.response, "Permission Denied");
            return;
          }
          // Handle errors
          console.error('Error making request:', error);
        });
    }
    setdupadata(newarr);
    setMaterialName(opt);
    setIndex(Index);
    setSowIndex(scopeIndex);
    setMaterialID(materialId++);
  };

  const createOptionMaterial = (opt, meta, scopeIndex, Index) => {
    let newarr = [...listMaterial];
    let a = newId;
    newarr.push({
      value: -1,
      label: opt,
    });

    setlistMaterial(newarr);

    let newdata = [...dupadata];
    newdata[scopeIndex].material[Index].description = opt;
    newdata[scopeIndex].material[Index].material_id = -1;
    newdata[scopeIndex]['edit'] = true;
    if (opt) {
      newdata[scopeIndex].material[Index].isEmpty = false;
    }
    setMaterialName(opt);
    setnewId(a--);
    setdupadata(newdata);
  };

  const matquantityonchange = (val, scopeIndex, Index, recommend = true) => {
    clearTimeout(quantityTimer);

    let newdata = [...dupadata];
    newdata[scopeIndex].material[Index].estimated_quantity = val ? parseFloat(val) : 0;
    newdata[scopeIndex].material[Index]['edit'] = true;
    newdata[scopeIndex]['edit'] = true;

    // check if calculator is 1
    if (newdata[scopeIndex].material[Index].calculator == 1) {
      newdata[scopeIndex].material[Index].has_quantity_rec = 0;
      delete newdata[scopeIndex].material[Index].recommendations['quantity'];
      recommend = false;
    }

    if (recommend && isEstimateRecoToolAllowed) {
      // debounce
      quantityTimer = setTimeout(() => {
        let phaseId = newdata[scopeIndex].phase_id;
        let sowId = newdata[scopeIndex].sow_id;
        let materialId = newdata[scopeIndex].material[Index].material_id;
        hasRecommendedMaterialQuantity(phaseId, sowId, materialId, scopeIndex, Index);
      }, 1000);
    }

    setdupadata(newdata);
  };

  const matunitonchange = (val, scopeIndex, Index) => {
    let newdata = [...dupadata];
    newdata[scopeIndex].material[Index].unit = val;
    newdata[scopeIndex]['edit'] = true;
    setdupadata(newdata);
  };

  // NOTE: trigger recommendation if recommend=true
  const matunitoncostchange = (val, scopeIndex, Index, recommend = true) => {
    clearTimeout(unitCostTimer);

    let newdata = [...dupadata];
    newdata[scopeIndex].material[Index].unit_cost = val ? parseFloat(val) : 0;
    newdata[scopeIndex]['edit'] = true;
    newdata[scopeIndex].material[Index]['edit'] = true;

    if (recommend && isEstimateRecoToolAllowed) {
      // debounce
      unitCostTimer = setTimeout(() => {
        let materialId = newdata[scopeIndex].material[Index].material_id;
        let material = newdata[scopeIndex].material[Index].description;
        let price = newdata[scopeIndex].material[Index].unit_cost;
        let pm_id = newdata[scopeIndex].material[Index].id;
        hasRecommendedMaterialPrice(scopeIndex, Index, pm_id, materialId, material, price);
      }, 1000);
    }

    setdupadata(newdata);
  };

  const editLabor = (scopeIndex, Index) => {
    let newArr = [...sortedData];

    newArr[scopeIndex].labor[Index].edit = true;
    newArr[scopeIndex].title = 'Labor';

    setdupadata(newArr);
    setCalculatorTitle('Labor');
  };

  const editEquipment = (scopeIndex, Index) => {
    let newArr = [...sortedData];

    newArr[scopeIndex].equipment[Index].edit = true;
    newArr[scopeIndex].title = 'Equipment';

    setdupadata(newArr);
    setCalculatorTitle('Equipment');
  };

  const editMaterial = (scopeIndex, Index) => {
    let newArr = [...sortedData];

    newArr[scopeIndex].material[Index].edit = true;
    if (newArr[Index]) {
      newArr[scopeIndex].title = 'Material';
    }

    setdupadata(newArr);
    setCalculatorTitle('Material');
  };

  const editLaborTotal = (Index) => {
    let newArr = [...dupadata];
    newArr[Index]['edit_labor_cost'] = true;
    newArr[Index]['edit'] = true;
    setdupadata(newArr);
  };

  const editEquipmentTotal = (Index) => {
    let newArr = [...dupadata];
    newArr[Index]['edit_equipment_cost'] = true;
    newArr[Index]['edit'] = true;
    setdupadata(newArr);
  };


  const getStandardPhases = () => {

    $axios.get(`phase/v2/?limit=25&standard=1&project_id=${projectID}`).then((res) => {
      if (res.data.status == 1) {
        setPhases(res.data.response.data);
      }
    });
  };

  const getdetailed = (project_id) => {
    GetEstimate(project_id)
      .then((res) => {
        if (res.data.response.detailed.length != 1) {

          setgrantTotal(ceilToDecimalPlacesPayload(res.data.response.detailed.grand_total, 2));
          setestimateStatus(res.data.response.estimate_status);
          setdupadata(ceilToDecimalPlacesPayload(res.data.response.detailed.items, 2));
          setbuttonTransition(false);
          setHasVAT(res.data.response.has_vat);
          setDateUpdated(res.data.response.date_updated);
          setUpdatedBy(res.data.response.updated_by);
        }

        seterrorHandling(false);
        setLoading(false);
      })
      .catch((error) => {
        if (error?.response?.status === 403) {
          showError(error?.response?.data?.response, "Permission Denied");
          return;
        }
        console.error(error);
      });
  };

  const searchSow = async (e) => {
    let arr = [...sowSearchOptions];
    let search = e;

    let sow_filter = arr.filter((a) => a.label.toLowerCase() == search.toLowerCase());
    let sow_id = sow_filter.length != 0 ? sow_filter[0].value : '';
    setSearchLoading(true);
    await SearchSow(data, projectID, sow_id, search.toLowerCase())
      .then((res) => {
        if (res.data.response.detailed.length != 1) {
          setgrantTotal(ceilToDecimalPlacesPayload(res.data.response.detailed.grand_total, 2));
          setestimateStatus(res.data.response.estimate_status);
          setdupadata(ceilToDecimalPlacesPayload(res.data.response.detailed.items, 2));
          setbuttonTransition(false);
          setHasVAT(res.data.response.has_vat);
          setDateUpdated(res.data.response.date_updated);
          setUpdatedBy(res.data.response.updated_by);
          setSearchLoading(false);
        }

        seterrorHandling(false);
        setLoading(false);
      })
      .catch((error) => {
        if (error?.response?.status === 403) {
          showError(error?.response?.data?.response, "Permission Denied");
          return;
        }
        console.error(error);
      });
  };

  const debouncedSearchSow = debounce(searchSow, 300);

  const hasRecommendedMaterialQuantity = (phaseId, sowId, materialId, scopeIndex, index) => {
    const requestData = {
      type: 3,
      phase_id: phaseId,
      sow_id: sowId,
      project_id: projectID,
      type_id: materialId,
    };

    $axios({
      method: 'post',
      url: IP + 'calculator/detail',
      data: requestData,
      headers: {
        'content-type': 'application/vnd.myapp.type+json',
        Authorization: `Bearer ${accessToken}`,
      },
    }).then((res) => {
      if (res.status == 200) {

        // for new items in Estimate
        if (dupadata[scopeIndex].material[index].id == 0) {
          let newData = [...dupadata];
          newData[scopeIndex].material[index].has_quantity_rec = parseInt(res.data.response == 'No Data');
          setdupadata(newData);
        }

        if (res.data) {
          let activeIndex = { ...activeRecommenderIndex3 };

          if (!(scopeIndex in activeIndex)) {
            activeIndex[scopeIndex] = {};
          }

          if (!(index in activeIndex[scopeIndex])) {
            activeIndex[scopeIndex][index] = { isOpen: true, isLoading: true };
          }

          setActiveRecommenderIndex3(activeIndex);
          setShowRecommender3(true);
          // markRecommendedItem('quantity', scopeIndex, index, 1)
          getRecommendedMaterialQuantity(scopeIndex, index);
        } else {
          setShowRecommender3(false);
        }
      }
    });
  };

  const getRecommendedMaterialQuantity = (scopeIndex, index) => {
    let params = {
      phase_id: dupadata[scopeIndex].phase_id,
      sow_id: dupadata[scopeIndex].sow_id,
      area: parseFloat(dupadata[scopeIndex].measurement),
      unit_id: dupadata[scopeIndex].unit_id,
      material_id: dupadata[scopeIndex].material[index].material_id,
      material_desc: dupadata[scopeIndex].material[index].description,
      pm_id: dupadata[scopeIndex].material[index].id,
      quantity: dupadata[scopeIndex].material[index].estimated_quantity,
      project_id: projectID,
    };

    $axios({
      method: 'post',
      url: IP + 'material/get-quantity-recommendation',
      data: params,
      headers: {
        'content-type': 'application/vnd.myapp.type+json',
        Authorization: `Bearer ${accessToken}`,
      },
    }).then((res) => {
      if (res.status == 200) {
        if (res.data.response?.options.length > 0) {
          let newData = [...dupadata];
          let activeIndex = { ...activeRecommenderIndex3 };

          if (!(scopeIndex in activeIndex)) {
            activeIndex[scopeIndex] = {};
          }

          newData[scopeIndex].material[index].recommendations['quantity'] = res.data.response;
          activeIndex[scopeIndex][index] = { isOpen: true, isLoading: false, ...res.data.response };
          setActiveRecommenderIndex3(activeIndex);
          setShowRecommender3(true);
          markRecommendedItem('quantity', scopeIndex, index, 1);
        } else {
          let newData = [...dupadata];
          let recommendations = newData[scopeIndex].material[index].recommendations;
          newData[scopeIndex].material[index].has_quantity_rec = null;

          if ('quantity' in recommendations) {
            delete newData[scopeIndex].material[index].recommendations['quantity'];
          }
          setdupadata(newData);
          setShowRecommender3(false);
        }
      }
    });
  };

  const markRecommendedItem = (recommendationType, scopeIndex, Index, flagValue) => {
    const newData = [...dupadata];

    if (recommendationType == 'price') {
      newData[scopeIndex].material[Index].has_price_rec = flagValue;
      setdupadata(newData);
    } else if (recommendationType == 'quantity') {
      newData[scopeIndex].material[Index].has_quantity_rec = flagValue;
      setdupadata(newData);
    }

  };

  // NOTE: flagValue is used to set has_price_rec in database
  // NOTE: flagValue=1 should only be triggered on unit price edit
  const hasRecommendedMaterialPrice = (scopeIndex, Index, pm_id, material_id, material, price) => {
    $axios({
      method: 'post',
      url: IP + 'material/has-price-recommendation',
      data: { material, material_id, price, pm_id },
      headers: {
        'content-type': 'application/vnd.myapp.type+json',
        Authorization: `Bearer ${accessToken}`,
      },
    }).then((res) => {
      if (res.status == 200) {
        if (res.data.response?.options.length > 0) {
          let newData = [...dupadata];

          // for new items in Estimate
          if (dupadata[scopeIndex].material[Index].id == 0) {
            newData[scopeIndex].material[Index].has_price_rec = 1;
          }

          let activeIndex = { ...activeRecommenderIndex2 };

          if (!(scopeIndex in activeIndex)) {
            activeIndex[scopeIndex] = {};
          }

          activeIndex[scopeIndex][Index] = {
            isOpen: true,
            isLoading: false,
            ...res.data.response,
          };

          newData[scopeIndex].material[Index].recommendations['price'] = res.data.response;
          setdupadata(newData);
          setActiveRecommenderIndex2(activeIndex);
          setShowRecommender2(true);
          markRecommendedItem('price', scopeIndex, Index, 1);
        } else {
          let newData = [...dupadata];
          let recommendations = newData[scopeIndex].material[Index].recommendations;
          newData[scopeIndex].material[Index].has_price_rec = null;

          if ('price' in recommendations) {
            delete newData[scopeIndex].material[Index].recommendations['price'];
          }

          setdupadata(newData);
          setShowRecommender2(false);
        }
      }
    });
  };

  const getUnits = () => {
    $axios({
      method: 'get',
      url: IP + 'estimate/units',
      headers: {
        'content-type': 'application/vnd.myapp.type+json',
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((res) => {
        if (res.status == 200) {
          setUnits(res.data.response);
        } else {
          Swal.fire({
            icon: 'error',
            title: res.data.response,
            text: res.data.description,
            confirmButtonColor: '#23303D',
          });
        }
      })
      .catch((error) => {
        if (error?.response?.status === 403) {
          showError(error?.response?.data?.response, "Permission Denied");
          return;
        }
        Swal.fire({
          icon: 'error',
          title: error?.response?.data?.message,
          text: error?.response?.data?.response,
          confirmButtonColor: '#23303D',
        });
      });
  };

  const getmanpower = () => {
    GetManpowerPosition(false)
      .then((res) => {
        if (res.status == 200) {
          setlistLabor(res.data.response);
        }
      })
      .catch((error) => {
        if (error?.response?.status === 403) {
          showError(error?.response?.data?.response, "Permission Denied");
          return;
        }
        console.error(error);
      });
  };


  const getequipment = () => {
    const company_id = parseInt(localStorage.getItem('company_id'));
    // temporary fix to get equipment drop-down
    $axios
      .get('equipment/category/list2', {
        company_id: company_id,
      })
      .then((res) => {
        setlistEquipment(res.data.response);
      })
      .catch((error) => {
        if (error?.response?.status === 403) {
          showError(error?.response?.data?.response, "Permission Denied");
          return;
        }
        console.error(error);
      });
    // temporary fix to get equipment drop-down
  };

  const getmaterial = () => {
    let company_id = parseInt(localStorage.getItem('company_id'));
    $axios
      .get(`estimate/material-list/${company_id}`)
      .then((res) => {
        if (res.data.status == 200) {
          setlistMaterial(res.data.response);
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: res.data.message,
            confirmButtonColor: '#23303D',
          });
        }
      })
      .catch((error) => {
        if (error?.response?.status === 403) {
          showError(error?.response?.data?.response, "Permission Denied");
          return;
        }
        console.error(error);
      });
  };

  const debouncedFetchOptions = useCallback(
    debounce((input, scope) => {
      if (input) {
        getsowlist(projectID, ['UPDATE_SOW_OPTION'], scope?.phase_category_id, input);
      } else {
        // get all work items
        getsowlist(projectID, ['UPDATE_SOW_OPTION'], scope?.phase_category_id);
      }
    }, 500),
    [],
  );


  const getsowlist = (project_id = null, method = ['UPDATE_SOW_OPTION'], phase_id = null, sowInput = null) => {
    // if need to fetch all work items but completeWorkItemList is not null
    // No need to fetch all list from backend
    if (!project_id && !phase_id && !sowInput && completeWorkItemList) {
      let sowOptionNew = { ...sowOptions };
      sowOptionNew[-1] = completeWorkItemList;
      setSowOption(sowOptionNew);
    } else {
      let url = `phase/v2/sowlist/?project_id=${project_id}&standard=1&phase_category_id=${phase_id}&sowInput=`;
      let company_id = parseInt(localStorage.getItem('company_id'));

      if (sowInput) {
        url = `phase/v2/sowlist/?project_id=${project_id}&standard=1&phase_category_id=${phase_id}&sowInput=${sowInput}`;
      }

      $axios
        .get(url, {
          company_id: company_id,
        })
        .then((res) => {
          if (method.includes('UPDATE_SOW_OPTION') && res.data.response?.length > 0) {
            let sowOptionNew = { ...sowOptions };

            // if getting all work items and completeWorkItemList is empty
            if (!project_id && !phase_id && !sowInput && !completeWorkItemList) {
              completeWorkItemList = res.data.response;
            }

            if (!phase_id) {
              // no assigned phase yet. Assign to phase id -1 temporarily
              sowOptionNew[-1] = res.data.response;
            } else {
              sowOptionNew[phase_id] = res.data.response;
            }
            setSowOption(sowOptionNew);
          }

          if (method.includes('UPDATE_SOW_SEARCH_OPTION')) {
            setSowSearchOptions(res.data.response);
          }
        })
        .catch((error) => {
          if (error?.response?.status === 403) {
            showError(error?.response?.data?.response, "Permission Denied");
            return;
          }
          console.error(error);
        });
    }
  };

  const toggleShow = (value) => {
    const shownState = togglescope.slice();
    const index = shownState.indexOf(value);

    if (index >= 0) {
      shownState.splice(index, 1);
      settogglescope(shownState);
    } else {
      shownState.push(value);
      settogglescope(shownState);
    }
  };

  const EstWorkers = (val, scopeIndex, Index, fromCalculator) => {
    if (fromCalculator === 1) {
      let newArr = [...dupadata];
      newArr[scopeIndex].labor[Index].estimated_workers = parseInt(val);
      newArr[scopeIndex].edit = true;
      setdupadata(newArr);
    } else {
      let newArr = [...dupadata];
      newArr[scopeIndex].labor[Index].estimated_workers = val ? parseInt(val) : 0;
      newArr[scopeIndex]['edit'] = true;
      newArr[scopeIndex].labor[Index].calculator = 0;
      setdupadata(newArr);
    }
  };

  const rateOnchgange = (val, scopeIndex, Index) => {
    let newArr = [...dupadata];
    newArr[scopeIndex].labor[Index].rate = val ? parseFloat(val) : 0;
    newArr[scopeIndex]['edit'] = true;
    setdupadata(newArr);
  };

  const estimateValidation = (data) => {
    const uniqueCombinations = new Set();
    const hasAnyRemoveSow = data.some((item) => item.remove_sow === true);
    data.forEach((item) => {
      if (!item.new) {
        const combinationKey = `${item.phase_id}-${item.sow_id}`;
        uniqueCombinations.add(combinationKey);
      }
    });
    const newData = data.map((order, index) => {
      const toggleOptions = (Index) => {
        setShowOptions((prevOptions) => {
          const newOptions = [...prevOptions];
          // Check if the current value is different from the previous value
          if (newOptions[Index] !== undefined) {
            if (newOptions[Index] === false) {
              newOptions[Index] = !newOptions[Index];
            } else {
              newOptions[Index] = newOptions[Index];
            }
          } else {
            newOptions[Index] = !newOptions[Index]; // Set to true if it doesn't exist
          }
          return newOptions;
        });
      };
      const hasEmptyLabor = order.labor.some((labor) => !labor.remove && labor.designation.trim() === '');
      const hasEmptyEquipment = order.equipment.some((equipment) => !equipment.remove && equipment.description.trim() === '');
      const hasEmptyMaterial = order.material.some((material) => !material.remove && material.description.trim() === '');
      if (hasEmptyLabor || hasEmptyEquipment || hasEmptyMaterial) {
        toggleOptions(index); // Call toggleOptions if there is any empty labor, equipment, or material
      }

      const isEmptyWork = order[0].trim() === '';
      const isEmptyPhase = order.phase.trim() === '';
      const isEmptyMeasurement = order.new && (order.measurement === 0 || order.measurement === null);
      const isEmpty = hasEmptyLabor || hasEmptyEquipment || hasEmptyMaterial || isEmptyWork || isEmptyPhase || isEmptyMeasurement;
      const combinationKey = `${order.phase_id}-${order.sow_id}`;
      const isDuplicate = order.new && uniqueCombinations.has(combinationKey);

      if (!hasAnyRemoveSow) {
        if (isDuplicate) {
          return { ...order, isEmpty: true, isDuplicate: true };
        }
      }

      const updatedOrder = {
        ...order,
        isEmptyWork,
        isEmptyPhase,
        labor: order.labor.map((labor) => ({
          ...labor,
          isEmpty: labor.designation.trim() === '' ? true : false,
          edit: labor.designation.trim() === '' && labor.edit != true ? true : labor.edit,
        })),
        equipment: order.equipment.map((equipment) => ({
          ...equipment,
          isEmpty: equipment.description.trim() === '' ? true : false,
          edit: equipment.description.trim() === '' && equipment.edit != true ? true : equipment.edit,
        })),
        material: order.material.map((material) => ({
          ...material,
          isEmpty: material.description.trim() === '' ? true : false,
          edit: material.description.trim() === '' && material.edit != true ? true : material.edit,
        })),
      };

      return { ...updatedOrder, isEmpty, isDuplicate: false }; // Update isEmpty property of the order
    });

    setdupadata(newData);
    return newData;
  };

  const scrollToElement = (identifier) => {
    const element = document.querySelector(identifier);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      console.error(`Element with identifier "${identifier}" not found.`);
    }
  };

  const autoScroll = (orderWithEmptyField) => {
    let identifier;
    let idOfEmpty;
    if (orderWithEmptyField.labor.some((labor) => labor.isEmpty)) {
      idOfEmpty = orderWithEmptyField.labor.find((labor) => labor.isEmpty).id;
      identifier = `#labor-row-${idOfEmpty}`;
    } else if (orderWithEmptyField.equipment.some((equipment) => equipment.isEmpty)) {
      idOfEmpty = orderWithEmptyField.equipment.find((equipment) => equipment.isEmpty).id;
      identifier = `#equipment-row-${idOfEmpty}`;
    } else if (orderWithEmptyField.material.some((material) => material.isEmpty)) {
      idOfEmpty = orderWithEmptyField.material.find((material) => material.isEmpty).id;
      identifier = `#material-row-${idOfEmpty}`;
    }
    if (identifier) {
      setTimeout(() => {
        scrollToElement(identifier);
      }, 0);
    }
  };

  const checkVarianceOrder = () => {
    let data = [...dupadata];
    let checkedData = estimateValidation(data);

    const isDuplicate = checkedData.some((order) => order.isDuplicate);
    const hasEmptyFields = checkedData.some((order) => order.isEmpty);
    const indexOfEmpty = checkedData.findIndex((order) => order.isEmpty);
    setdupadata(checkedData);

    if (isDuplicate) {
      Swal.fire({ icon: 'error', title: 'Error', text: 'This scope of work and work item already exists.', confirmButtonColor: '#23303D' });
      return;
    }
    if (hasEmptyFields) {
      const confirmation = window.confirm('Please fill in all required fields.');
      if (confirmation || !confirmation) {
        autoScroll(checkedData[indexOfEmpty]);
      }
      return;
    }
    let val = data.filter((a) => a.new == true || a.edit == true || a.remove_sow);

    if (val.length === 0 && isTotalActualCostEdited === false) {
      window.alert('Please edit a scope of work first.');
    } else if (val.length > 0 && estimateStatus === 2) {
      let varianceOrder = val.filter((a) => (a.new || a.edit) && !a.remove_sow);
      if (varianceOrder.length > 0) {
        let hasVarianceOrderItems = false;
        varianceOrder.forEach((order) => {
          // Check labor
          if (order.labor && Array.isArray(order.labor)) {
            order.labor.forEach((labor) => {
              if ((labor.new || labor.edit) && !labor.remove) {
                hasVarianceOrderItems = true;
              }
            });
          }
          // Check equipment
          if (order.equipment && Array.isArray(order.equipment)) {
            order.equipment.forEach((equipment) => {
              if ((equipment.new || equipment.edit) && !equipment.remove) {
                hasVarianceOrderItems = true;
              }
            });
          }
          // Check material
          if (order.material && Array.isArray(order.material)) {
            order.material.forEach((material) => {
              if ((material.new || material.edit) && !material.remove) {
                hasVarianceOrderItems = true;
              }
            });
          }
        });

        if (hasVarianceOrderItems) {
          setModalVarianceOrder(!modalVarianceOrder);
          setVarianceOrderData(varianceOrder);
        } else {
          varianceOrder.forEach((order, index) => {
            updateItems(varianceOrder, index, false);
          });
          SaveSow(2);
        }
      } else {
        SaveSow(2);
      }
    } else {
      SaveSow(2);
    }
  };

  const SaveSow = (Status, varianceOrderData) => {
    let data = [];
    let val;
    if (varianceOrderData) {
      val = [...varianceOrderData];
    } else {
      data = [...dupadata];

      let checkedData = estimateValidation(data);
      setdupadata(checkedData);

      const isDuplicate = checkedData.some((order) => order.isDuplicate);
      const hasEmptyFields = checkedData.some((order) => order.isEmpty);
      const indexOfEmpty = checkedData.findIndex((order) => order.isEmpty);

      if (isDuplicate) {
        Swal.fire({ icon: 'error', title: 'Error', text: 'This scope of work and work item already exists.', confirmButtonColor: '#23303D' });
        return;
      }
      if (hasEmptyFields) {
        const confirmation = window.confirm('Please fill in all required fields.');
        if (confirmation || !confirmation) {
          autoScroll(checkedData[indexOfEmpty]);
        }

        return;
      }

      val = data.filter((a) => a.new == true || a.edit == true || a.remove_sow == true);

      val.forEach((order, index) => {
        updateItems(val, index, false);
      });

    }

    const grandTotalPayload = {};
    if (isTotalActualCostEdited) {
      grandTotalPayload.total_actual_labor_cost = grantTotal?.total_actual_labor_cost;
      grandTotalPayload.total_actual_equipment_cost = grantTotal?.total_actual_equipment_cost;
    }
    if (val.length === 0 && isTotalActualCostEdited === false) {
      window.alert('Please edit a scope of work first.');
    } else {
      setSearchLoading(true);
      $axios
        .post('estimate/save', {
          project_id: projectID,
          estimate_data: val,
          labor_total_actual_cost: isTotalActualCostEdited ? grandTotalPayload.total_actual_labor_cost : null,
          equipment_total_actual_cost: isTotalActualCostEdited ? grandTotalPayload.total_actual_equipment_cost : null,
          estimate_status: Status,
          company_id: company_id,
          user_id: user_id,
        })
        .then((res) => {
          if (res.data.status == 1) {
            const mixpanelData = val.flatMap(item => {
              const base = {
                psow_id: item.psow_id,
                sow_id: item.sow_id,
                phase: item.phase,
                title: item["0"],
              }

              return [
                ...(item.equipment || []).map(e => ({
                  ...base,
                  category: 'equipment',
                  name: e.description,
                  rate: e.rate,
                  estimated_cost: e.estimated_cost,
                  actual_cost: e.actual_cost,
                  balance: e.balance,
                })),

                ...(item.labor || []).map(l => ({
                  ...base,
                  category: 'labor',
                  name: l.designation,
                  rate: l.rate,
                  estimated_cost: l.estimated_cost,
                  actual_cost: l.actual_cost,
                  balance: l.balance,
                })),

                ...(item.material || []).map(m => ({
                  ...base,
                  category: 'material',
                  name: m.description,
                  rate: m.unit_cost,
                  estimated_cost: m.estimated_cost,
                  actual_cost: m.actual_cost,
                  balance: m.balance,
                })),
              ]
            })

            mixpanelData.forEach((item) => {
              trackEvent(mixPanelEvents.ADD_ESTIMATE, {
                'Source': 'Project Estimate',
                'Project ID': projectID,
                'AIMHI Version': 1,
                ...item,
              })
            })
            let newData = JSON.parse(JSON.stringify(data));
            for (let i = 0; i < newData.length; i++) {
              newData[i].new = false;
            }
            dispatch(triggerProjectRefetch(projectID));
            setdupadata([...newData]);
            getdetailed(projectID);
            isSubmitted.current = true;
            setWorkItemDescriptionList([]);
            getWorkItemDescription(projectID);
            if (isApprover) {
              Swal.fire({
                title: 'Success!',
                text: 'Your modifications have been submitted successfully',
                icon: 'success',
                confirmButtonText: 'Continue',
              });
            } else {
              Swal.fire({
                title: 'Success!',
                text: 'Your modifications have been submitted successfully and are now pending approval.',
                icon: 'success',
                confirmButtonText: 'Continue',
              });
            }
          } else {
            Swal.fire({
              icon: 'error',
              title: res.data.response,
              text: res.data.description,
              confirmButtonColor: '#23303D',
            });
          }
        })
        .catch((error) => {
          if (error?.response?.status === 403) {
            showError(error?.response?.data?.response, "Permission Denied");
            return;
          }
          console.error(error);
        })
        .finally(() => setSearchLoading(false));
    }
  };



  const removeLabor = (scopeIndex, Index) => {
    const newArr = [...dupadata];
    newArr[scopeIndex].labor[Index]['remove'] = true;
    newArr[scopeIndex]['edit'] = true;
    setdupadata(newArr);
  };

  const removeEquipment = (scopeIndex, Index) => {
    const newArr = [...dupadata];
    newArr[scopeIndex].equipment[Index]['remove'] = true;
    newArr[scopeIndex]['edit'] = true;
    setdupadata(newArr);
  };

  const removeMaterial = (scopeIndex, Index) => {
    const newArr = [...dupadata];
    newArr[scopeIndex].material[Index]['remove'] = true;
    newArr[scopeIndex]['edit'] = true;
    setdupadata(newArr);
  };

  const start = () => {
    if (dupadata.length == 0) {
      let newarray = [...dupadata];

      let newdata = JSON.stringify(empty_format);
      newarray.push(JSON.parse(newdata));

      setdupadata(newarray);
      setbuttonTransition(true);
    }
  };

  const areaORVolumeUnitOnChange = (opt, scopeIndex) => {
    let newdata = [...dupadata];
    newdata[scopeIndex].unit_id = opt;
    setdupadata(newdata);

    // Update the area_unit_id in the equipmentProductivity state
    setEquipmentProductivity((prevState) => {
      let newState = [...prevState];
      if (newState[0]) {
        newState[0].area_unit_id = opt;
      }
      return newState;
    });
    // Update the area_unit_id in the laborProductivity state
    setLaborProductivity((prevState) => {
      let newState = [...prevState];
      if (newState[0]) {
        newState[0].area_unit_id = opt;
      }
      return newState;
    });
  };

  const areaOrVolumeOnChange = (val, scopeIndex) => {
    let newdata = [...dupadata];
    newdata[scopeIndex].measurement = val;
    if (val > 0) {
      newdata[scopeIndex].isEmptyMeasurement = false;
    }
    setdupadata(newdata);
    if (newdata[scopeIndex].equipment.length > 0) {
      // Update the area_value in the equipmentProductivity state
      setEquipmentProductivity((prevState) => {
        let newState = [...prevState];
        if (newState[0]) {
          newState[0].area_value = val;
        }
        return newState;
      });
    }
    if (newdata[scopeIndex].labor.length > 0) {
      // Update the area_value in the equipmentProductivity state
      setLaborProductivityForCalculator((prevState) => {
        let newState = [...prevState];
        if (newState[0]) {
          newState[0].area_value = val;
        }
        return newState;
      });
    }
    if (newdata[scopeIndex].material.length > 0) {
      setMaterialQuantityForCalculator((prevState) => {
        let newState = [...prevState];
        if (newState[0]) {
          if (newState[0].data[0].unit_area_value) {
            newState[0].data[0].unit_area_value = val;
          } else {
            newState[0].area_value = val;
          }
        }
        return newState;
      });
    }
  };

  const submitCategory = () => {
    const data = {
      category_name: category,
      company_id: company_id,
    };
    $axios
      .post('equipment/category/create', data)
      .then((res) => {
        if (res.status == 200) {
          Swal.fire('Success', 'Equipment category created succesfully', 'success');
          getequipment();
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Already Exists',
            text: `The equipment category '${category}' already exists`,
            confirmButtonColor: '#23303D',
          });
        }
        onCloseCategory();
      })
      .catch((error) => {
        if (error?.response?.status === 403) {
          showError(error?.response?.data?.response, "Permission Denied");
          return;
        }
        console.error('API Error:', error);
      });

    EquipmentCalculatorDetail(sowIndex);
  };

  const submitPosition = () => {
    let data = {
      position: position,
      description: positionDescription,
    };

    AddPosition(data)
      .then((res) => {
        if (res.status == 200) {
          Swal.fire('Success', 'Manpower position created succesfully', 'success');
          getmanpower();
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Already Exists',
            text: `The position '${position}' already exists`,
            confirmButtonColor: '#23303D',
          });
        }
        onClosePosition();
      })
      .catch((error) => {
        if (error?.response?.status === 403) {
          showError(error?.response?.data?.response, "Permission Denied");
          return;
        }
        console.error('API Error:', error);
      });
  };

  const onCloseCategory = () => {
    setCategory('');
    setModalCategory(!modalCategory);
  };

  const onClosePosition = () => {
    setPosition('');
    setPositionDescription('');
    setModalPosition(!modalPosition);
  };

  const workTypeOnChange = (opt, scopeIndex) => {
    let newdata = [...dupadata];
    newdata[scopeIndex].is_sub_con = parseInt(opt.target.value);

    if (newdata[scopeIndex].is_sub_con === 1 && newdata[scopeIndex].edit === true) {
      newdata[scopeIndex]?.labor.map((labor) => {
        labor.is_sub_con = true;
        labor.edit = true;
      });
      newdata[scopeIndex]?.equipment.map((equipment) => {
        equipment.is_sub_con = true;
        equipment.edit = true;
      });
    }
    newdata[scopeIndex]['edit'] = true;

    if (opt.target.value === '0') {
      newdata[scopeIndex]?.labor.map((labor) => {
        labor.is_sub_con = false;
        labor.edit = true;
      });
      newdata[scopeIndex]?.equipment.map((equipment) => {
        equipment.is_sub_con = false;
        equipment.edit = true;
      });
      newdata[scopeIndex]?.material.map((material) => {
        material.is_sub_con = false;
        material.edit = true;
      });
    } else {
      newdata[scopeIndex]?.labor.map((labor) => {
        labor.is_sub_con = true;
        labor.edit = true;
      });
      newdata[scopeIndex]?.equipment.map((equipment) => {
        equipment.is_sub_con = true;
        equipment.edit = true;
      });
      newdata[scopeIndex]?.material.map((material) => {
        material.is_sub_con = true;
        material.edit = true;
      });
    }
  };

  const sowOptionSearch = sowSearchOptions.map((data, Index) => {
    return <option value={data.label} key={Index}></option>;
  });

  const setCalculatorStatus = (title, scopeIndex, Index) => {
    let newdata = [...dupadata];

    if (title === 'Labor') {
      newdata[scopeIndex].labor[Index].calculator = 1;
    } else if (title === 'Equipment') {
      newdata[scopeIndex].equipment[Index].calculator = 1;
    } else {
      newdata[scopeIndex].material[Index].calculator = 1;
    }
    setdupadata(newdata);
  };


  const isSubmitted = useRef(false);
  const prevOrderBy = useRef(null);
  const sortedData = useMemo(() => {
    if (!dupadata || dupadata.length === 0) return [];
    const shallowDupa = [...dupadata];

    if (props?.order_by !== prevOrderBy.current || isSubmitted.current) {

      const newItems = shallowDupa.filter(item => item.isNew);
      const oldItems = shallowDupa.filter(item => !item.isNew);

      const sortedOldItems = [...oldItems].sort((a, b) =>
        props?.order_by === "Description"
          ? (a?.tag_name || "").localeCompare(b?.tag_name || "")
          : (a?.phase || "").localeCompare(b?.phase || "")
      );

      prevOrderBy.current = props?.order_by;
      isSubmitted.current = false;
      return [...newItems, ...sortedOldItems];
    }

    return shallowDupa;
  }, [props?.order_by, dupadata]);

  const tbody = sortedData.map((scope, Index) => {

    let Total_Labor = 0;
    let Total_Equipment = 0;
    let Total_Material = 0;
    let scopeIndex = Index;

    let tableClass = scope['remove_sow'] == true ? 'disable_table table table-sm' : 'table table-sm';

    const phaseCustomStyles = {
      control: (provided) => ({
        ...provided,
        borderColor: scope.isEmptyPhase ? '#B42A19' : '#ccc',
      }),
    };

    const sowCustomStyles = {
      control: (provided) => ({
        ...provided,
        borderColor: scope.isEmptyWork ? '#B42A19' : '#ccc',
      }),
    };

    const toggleOptions = (Index) => {
      setShowOptions((prevOptions) => {
        const newOptions = [...prevOptions];
        newOptions[Index] = !newOptions[Index];
        return newOptions;
      });
    };

    const Labor = scope.labor.map((labor, Index) => {
      const laborCustomStyles = {
        control: (provided) => ({
          ...provided,
          borderColor: labor.isEmpty ? '#B42A19' : '#ccc',
        }),
      };
      Total_Labor += labor.estimate;

      let rowClass = 'text-center';
      if (labor.remove == true) {
        rowClass = 'text-center disable-table-column';
      }

      if (labor.is_sub_con) {
        scope.is_sub_con = 1;
      }

      return (
        <tr key={Index} className={rowClass} style={{ fontSize: '14px', backgroundColor: labor.is_archived === 1 ? '#d9d9d9' : 'transparent' }} id={`labor-row-${labor.id}`}>
          <td align="left">
            {labor.edit == true ? (
              <>
                <div style={{ display: 'flex' }}>
                  <div style={{ flex: 1, marginRight: '10px' }}>
                    <CreatableSelect
                      styles={laborCustomStyles}
                      value={{ label: labor.designation, value: labor.id }}
                      options={listLabor}
                      onChange={(opt, meta) => LaborOnchange(opt, meta, scopeIndex, Index)}
                      onCreateOption={(opt, meta) => createOption(opt, meta, scopeIndex, Index)}
                      style={{ borderColor: 'red' }}
                    />
                  </div>
                  {labor.isEmpty && <CLabel style={{ color: '#B42A19' }}>Labor designation is required.</CLabel>}

                  {labor.show_calculator === 1 ? <AIButton className={labor.dataAvailable ? 'ai-icon' : ''} toggleCalculator={toggleCalculator} scopeIndex={scopeIndex} Index={Index} title={'Labor'} /> : null}
                </div>
              </>
            ) : (
              <>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span style={{ marginRight: '20px' }}>{labor.designation}</span>
                  {labor.is_variance_order && (
                    <CBadge color="aimhi-success" className="badge-stats">
                      Variance Order
                    </CBadge>
                  )}
                </div>
              </>
            )}
          </td>
          <td>
            {labor.edit == true ? (
              <CInput type="number" placeholder={0} value={labor.estimated_workers === 0 ? '' : labor.estimated_workers} onChange={(e) => EstWorkers(e.target.value, scopeIndex, Index, 0)} step="any" onKeyDown={preventInvalidKeys} onWheel={blurOnWheel} onPaste={preventInvalidPaste} />
            ) : (
              <>
                <div></div>
                {labor.estimated_workers}
                {labor.calculator === 1 && isEstimateRecoToolAllowed ? (
                  <BackupButton
                    toggleCalculator={() => toggleCalculator({ history_title: 'Labor', scopeIndex, Index })}
                    projectID={projectID}
                    dupadata={dupadata}
                    scopeIndex={scopeIndex}
                    Index={Index}
                    accessToken={accessToken}
                    setLaborProductivityForCalculator={setLaborProductivityForCalculator}
                    title={'Labor'}
                    editLabor={editLabor}
                  />
                ) : (
                  ''
                )}

              </>
            )}
          </td>
          <td>{labor.edit == true ? <CInput placeholder={'0 days'} value={labor.duration === '0 days' ? '' : labor.duration} onChange={(e) => durationOnchange(e.target.value, scopeIndex, Index, 0)} /> : labor.duration}</td>
          <td style={{ textAlign: 'right' }}>
            {labor.edit == true ? (
              <CInput type="number" placeholder={0} value={labor.rate === 0 ? '' : labor.rate} onChange={(e) => rateOnchgange(e.target.value, scopeIndex, Index)} step="any" onKeyDown={preventInvalidKeys} onWheel={blurOnWheel} onPaste={preventInvalidPaste} />
            ) : (
              <span>
                <NumberFormat value={labor.rate} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
              </span>
            )}
          </td>
          <td style={{ textAlign: 'right' }}>
            <NumberFormat value={labor.estimated_cost} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
          </td>
          <td>{labor.edit == true && estimateStatus === 2 ? <CInput type="number" placeholder={0} value={labor.hired_workers === 0 ? '' : labor.hired_workers} onChange={(e) => LaborHiredWorkers(e.target.value, scopeIndex, Index)} step="any" onKeyDown={preventInvalidKeys} onWheel={blurOnWheel} onPaste={preventInvalidPaste} /> : labor.hired_workers}</td>
          <td style={{ textAlign: 'right', backgroundColor: '#5497613d' }}>

            <span>
              {labor.is_auto_compute == false ? (
                <CTooltip content="This actual cost is edited and not auto computed." placement="right-end" color="white">
                  <span>
                    <NumberFormat value={labor.actual_cost} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                    <FaRegQuestionCircle
                      style={{
                        width: '15px',
                        height: '15px',
                        marginLeft: '5px',
                        color: '#757070',
                      }}
                    />
                  </span>
                </CTooltip>
              ) : (
                <span onClick={() => scrollToElement('#target-section')} role="button">
                  <CTooltip content="Click here to update total actual cost for labor" placement="right-end" color="white">
                    <NumberFormat value={labor.actual_cost} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                  </CTooltip>
                </span>
              )}
            </span>
          </td>

          <td style={{ textAlign: 'right' }}>

            <NumberFormat
              value={labor.balance}
              displayType={'text'}
              thousandSeparator={true}
              decimalScale={2}
              fixedDecimalScale={true}
              style={{
                marginLeft: '5px',
                color: labor.balance < 0 ? '#B42A19' : '',
              }}
            />
            {labor.remove != true && (
              <span style={{ marginLeft: '10px' }} className="float-right" id={Index}>
                {labor.is_archived === 1 ? (
                  <CTooltip content="This labor is archived">
                    <span className="ml-4">
                      <FaArchive />
                    </span>
                  </CTooltip>
                ) : (
                  <CDropdown size="sm">
                    <CDropdownToggle className="caret">
                      <span className="iconify" data-icon="akar-icons:more-vertical"></span>
                    </CDropdownToggle>
                    <CDropdownMenu>
                      <CDropdownItem header>Action</CDropdownItem>
                      <CDropdownDivider />
                      {checkPermission("/estimate/save") && (
                        <CDropdownItem onClick={() => editLabor(scopeIndex, Index)}>
                          <span className="iconify" data-icon="bi:pencil-square"></span>
                          <span style={{ marginLeft: '5px' }}>Edit</span>
                        </CDropdownItem>
                      )}
                      {checkPermission("/estimate/save") && (
                        <CDropdownItem onClick={() => removeLabor(scopeIndex, Index)}>
                          <span className="iconify" data-icon="akar-icons:minus"></span>
                          <span style={{ marginLeft: '5px' }}>Remove</span>
                        </CDropdownItem>
                      )}
                    </CDropdownMenu>
                  </CDropdown>
                )}
              </span>
            )}
          </td>
        </tr>
      );
    });

    const Equipment = scope.equipment.map((equipment, Index) => {
      const equipmentCustomStyles = {
        control: (provided) => ({
          ...provided,
          borderColor: equipment.isEmpty ? '#B42A19' : '#ccc',
        }),
      };
      Total_Equipment += equipment.estimate;

      let rowClass = 'text-center';

      if (equipment.remove == true) {
        rowClass = 'text-center disable-table-column';
      }

      if (equipment.is_sub_con) {
        scope.is_sub_con = 1;
      }

      return (
        <tr key={Index} className={rowClass} style={{ fontSize: '14px', backgroundColor: equipment.is_archived === 1 ? '#d9d9d9' : 'transparent' }} id={`equipment-row-${equipment.id}`}>
          <td align="left">
            {equipment.edit == true ? (
              <>
                <div style={{ display: 'flex' }}>
                  <div style={{ flex: 1, marginRight: '10px' }}>
                    <CreatableSelect
                      styles={equipmentCustomStyles}
                      value={{
                        label: equipment.description,
                        value: equipment.id,
                      }}
                      options={listEquipment}
                      onChange={(opt, meta) => EquipmentOnchange(opt, meta, scopeIndex, Index)}
                      isValidNewOption={() => false}
                    />
                    {equipment.isEmpty && <CLabel style={{ color: '#B42A19' }}>Equipment description is required.</CLabel>}
                  </div>
                  {equipment.show_calculator === 1 ? <AIButton className={equipment.dataAvailable ? 'ai-icon' : ''} toggleCalculator={toggleCalculator} scopeIndex={scopeIndex} Index={Index} title={'Equipment'} /> : null}
                </div>
              </>
            ) : (
              <>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <span style={{ marginRight: '20px' }}>{equipment.description}</span>
                  {equipment.is_variance_order && (
                    <CBadge color="aimhi-success" className="badge-stats">
                      Variance Order
                    </CBadge>
                  )}
                </div>
              </>
            )}
          </td>
          <td>
            {equipment.edit == true ? (
              <CInput type="number" placeholder={0} value={equipment.estimated_quantity === 0 ? '' : equipment.estimated_quantity} onChange={(e) => qtyonchange(e.target.value, scopeIndex, Index)} onKeyDown={preventInvalidKeys} onWheel={blurOnWheel} onPaste={preventInvalidPaste} />
            ) : (
              <>
                {' '}
                {equipment.estimated_quantity}
                {equipment.calculator === 1 && isEstimateRecoToolAllowed ? (
                  <BackupButton
                    toggleCalculator={() => toggleCalculator({ history_title: 'Equipment', scopeIndex, Index })}
                    projectID={projectID}
                    dupadata={dupadata}
                    scopeIndex={scopeIndex}
                    Index={Index}
                    accessToken={accessToken}
                    setEquipmentProductivityForCalculator={setEquipmentProductivityForCalculator}
                    title="Equipment"
                    editEquipment={editEquipment}
                  />
                ) : (
                  ''
                )}
              </>
            )}
          </td>
          <td>
            {equipment.edit == true ? (
              <CInput placeholder={'0 days'} value={equipment.duration === '0 days' ? '' : equipment.duration} onChange={(e) => eqdurationonchange(e.target.value, scopeIndex, Index)} />
            ) : (
              equipment.duration
            )}
          </td>

          <td style={{ textAlign: 'right' }}>
            {equipment.edit == true ? (
              <CInput type="number" placeholder={0} value={equipment.rate === 0 ? '' : equipment.rate} onChange={(e) => eqrateonchange(e.target.value, scopeIndex, Index)} onKeyDown={preventInvalidKeys} onWheel={blurOnWheel} onPaste={preventInvalidPaste} />
            ) : (
              <span>
                <NumberFormat value={equipment.rate} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
              </span>
            )}
          </td>
          <td style={{ textAlign: 'right' }}>
            <NumberFormat value={equipment.estimated_cost} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
          </td>
          <td>{equipment.edit == true && estimateStatus === 2 ? <CInput type="number" placeholder={0} value={equipment.ordered_quantity === 0 ? '' : equipment.ordered_quantity} onChange={(e) => EquipmentHiredWorkers(e.target.value, scopeIndex, Index)} onKeyDown={preventInvalidKeys} onWheel={blurOnWheel} onPaste={preventInvalidPaste} /> : equipment.ordered_quantity}</td>
          <td style={{ textAlign: 'right', backgroundColor: '#5497613d' }}>
            <span>
              {equipment.is_auto_compute == false ? (
                <CTooltip content="This actual cost is edited and not auto computed." placement="right-end" color="white">
                  <span>
                    <NumberFormat value={equipment.actual_cost} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                    <FaRegQuestionCircle
                      style={{
                        width: '15px',
                        height: '15px',
                        marginLeft: '5px',
                        color: '#757070',
                      }}
                    />
                  </span>
                </CTooltip>
              ) : (
                <span onClick={() => scrollToElement('#target-section')} role="button">
                  {' '}
                  <CTooltip content="Click here to update total actual cost for equipment" placement="right-end" color="white">
                    <NumberFormat value={equipment.actual_cost} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                  </CTooltip>
                </span>
              )}
            </span>
          </td>
          <td style={{ textAlign: 'right' }}>
            {/* Equipment Balance */}
            <NumberFormat
              value={equipment.balance}
              displayType={'text'}
              thousandSeparator={true}
              decimalScale={2}
              fixedDecimalScale={true}
              style={{
                marginLeft: '5px',
                color: equipment.balance < 0 ? '#B42A19' : '',
              }}
            />
            <span style={{ marginLeft: '10px' }} className="float-right">
              {equipment.is_archived === 1 ? (
                <CTooltip content="This equipment is archived">
                  <span className="ml-4">
                    <FaArchive />
                  </span>
                </CTooltip>
              ) : (
                equipment.remove !== true && (
                  <CDropdown>
                    <CDropdownToggle className="caret">
                      <span className="iconify" data-icon="akar-icons:more-vertical"></span>
                    </CDropdownToggle>
                    <CDropdownMenu>
                      <CDropdownItem header>Action</CDropdownItem>
                      <CDropdownDivider />
                      {checkPermission("/estimate/save") && (
                        <CDropdownItem onClick={() => editEquipment(scopeIndex, Index)}>
                          <span className="iconify" data-icon="bi:pencil-square"></span>
                          <span style={{ marginLeft: '5px' }}>Edit</span>
                        </CDropdownItem>
                      )}
                      {checkPermission("/estimate/save") && (
                        <CDropdownItem onClick={() => removeEquipment(scopeIndex, Index)}>
                          <span className="iconify" data-icon="akar-icons:minus"></span>
                          <span style={{ marginLeft: '5px' }}>Remove</span>
                        </CDropdownItem>
                      )}
                    </CDropdownMenu>
                  </CDropdown>
                )
              )}
            </span>
          </td>
        </tr>
      );
    });

    const Material = scope.material.map((material, Index) => {
      const materialCustomStyles = {
        control: (provided) => ({
          ...provided,
          borderColor: material.isEmpty ? '#B42A19' : '#ccc',
        }),
      };
      Total_Material += material.estimate;
      let rowClass = 'text-center';
      if (material.remove == true) {
        rowClass = 'text-center disable-table-column';
      }
      if (material.is_sub_con) {
        scope.is_sub_con = 1;
      }

      const PopUpUseCase2 = ({ size }) => {
        if (!isEstimateRecoToolAllowed) {
          return;
        }
        if (!material.has_price_rec && scopeIndex in activeRecommenderIndex2) {
          return <div style={{ height: '25px', width: '25px', display: 'hidden', marginLeft: '8px' }}></div>;
        }

        // no recommendations
        else if (!(scopeIndex in activeRecommenderIndex2) || !(Index in activeRecommenderIndex2[scopeIndex]) || !activeRecommenderIndex2[scopeIndex][Index].isOpen) {
          return null;
        }

        const isLoading = activeRecommenderIndex2[scopeIndex][Index].isLoading;
        let Component = null;

        if (isLoading) {
          if (scopeIndex in activeRecommenderIndex2 && Index in activeRecommenderIndex2[scopeIndex]) {
            let materialId = dupadata[scopeIndex].material[Index].material_id;
            let material = dupadata[scopeIndex].material[Index].description;
            let price = dupadata[scopeIndex].material[Index].unit_cost;
            let pm_id = dupadata[scopeIndex].material[Index].id;
            hasRecommendedMaterialPrice(scopeIndex, Index, pm_id, materialId, material, price);
          }
        } else {
          Component = (
            <ComponentUseCase2
              recommendations={activeRecommenderIndex2[scopeIndex][Index]}
              handleClose={() => {
                toggleRecommenderPopUp(2, false);
                hideRecommenderPopup(scopeIndex, Index, 'price');
              }}
              handleSubmit={() => markRecommendedItem('price', scopeIndex, Index, 0)}
              unitCostOnChange={matunitoncostchange}
              scopeIndex={scopeIndex}
              Index={Index}
            />
          );
        }

        return <RecommenderPopUp size={size}>{Component}</RecommenderPopUp>;
      };


      const existingMaterialIds = new Set(dupadata[scopeIndex]?.material?.map(m => m.material_id)) ?? [];

      const filteredMaterials = listMaterial.filter(
        item => !existingMaterialIds.has(item.value)
      );

      return (
        <tr key={Index} className={rowClass} style={{ fontSize: '14px', backgroundColor: material.is_archived === 1 ? '#d9d9d9' : 'transparent' }} id={`material-row-${material.id}`}>
          <td align="left">
            {material.edit == true ? (
              <>
                <div style={{ display: 'flex' }}>
                  <div style={{ flex: 1, marginRight: '10px' }}>
                    <CreatableSelect
                      styles={materialCustomStyles}
                      value={{
                        label: material.description,
                        value: material.id,
                      }}
                      options={filteredMaterials}
                      onChange={(opt, meta) => MaterialOnchange(opt, meta, scopeIndex, Index)}
                      onCreateOption={(opt, meta) => createOptionMaterial(opt, meta, scopeIndex, Index)}
                      isValidNewOption={(inputValue) => {
                        if (!inputValue?.trim()?.toLowerCase()) return false;
                        const exists = listMaterial.some(
                          m =>
                            m.label?.trim()?.toLowerCase() === inputValue?.trim()?.toLowerCase()
                        );
                        return !exists;
                      }}
                    />
                    {material.isEmpty && <CLabel style={{ color: '#B42A19' }}>Material description is required.</CLabel>}
                  </div>
                  {material.dataAvailable ? <AIButton className="ai-icon" toggleCalculator={toggleCalculator} scopeIndex={scopeIndex} Index={Index} title={'Material'} /> : null}
                </div>
              </>
            ) : (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ marginRight: '20px' }}>{material.description}</span>
                {material.is_variance_order && (
                  <CBadge color="aimhi-success" className="badge-stats">
                    Variance Order
                  </CBadge>
                )}
              </div>
            )}
          </td>
          <td style={{ display: 'flex', paddingLeft: '30px', justifyContent: 'center' }}>
            {material.edit == true ? (
              <div style={{ display: 'flex' }}>
                <div style={{ flex: '2' }}>
                  <CInput type="number" placeholder={0} value={material.estimated_quantity === 0 ? '' : material.estimated_quantity} onChange={(e) => matquantityonchange(e.target.value, scopeIndex, Index)} onKeyDown={preventInvalidKeys} onWheel={blurOnWheel} onPaste={preventInvalidPaste} />
                </div>
              </div>
            ) : (
              <div>
                {material.estimated_quantity}
                {material.calculator === 1 && isEstimateRecoToolAllowed ? (
                  <BackupButton
                    toggleCalculator={() => toggleCalculator({ history_title: 'Material', scopeIndex, Index })}
                    projectID={projectID}
                    dupadata={dupadata}
                    scopeIndex={scopeIndex}
                    Index={Index}
                    accessToken={accessToken}
                    setMaterialQuantityForCalculator={setMaterialQuantityForCalculator}
                    title={'Material'}
                    editMaterial={editMaterial}
                  />
                ) : null}
              </div>
            )}
          </td>
          <td>{material.edit == true ? <CInput type="text" value={material.unit} onChange={(e) => matunitonchange(e.target.value, scopeIndex, Index)} /> : material.unit}</td>

          {/* here use case 2 */}
          <td style={{ textAlign: 'right' }}>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              {material.edit ? (
                <CInput type="number" placeholder={0} value={material.unit_cost === 0 ? '' : material.unit_cost} onChange={(e) => matunitoncostchange(e.target.value, scopeIndex, Index)} onKeyDown={preventInvalidKeys} onWheel={blurOnWheel} onPaste={preventInvalidPaste} />
              ) : (
                <NumberFormat value={material.unit_cost} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
              )}
              {isEstimateRecoToolAllowed && <PopUpUseCase2 size={material.edit ? '' : 's'} />}
            </div>
          </td>
          {/* here use case 2 */}

          <td style={{ textAlign: 'right' }}>
            <NumberFormat value={material.estimated_cost} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
          </td>

          <td>{material.edit == true && estimateStatus === 2 ? <CInput type="number" placeholder={0} value={material.ordered_quantity === 0 ? '' : material.ordered_quantity} onChange={(e) => MaterialHiredWorkers(e.target.value, scopeIndex, Index)} step="any" onKeyDown={preventInvalidKeys} onWheel={blurOnWheel} onPaste={preventInvalidPaste} /> : material.ordered_quantity}</td>

          <td style={{ textAlign: 'right', backgroundColor: '#5497613d' }}>
            <NumberFormat value={material.actual_cost} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
          </td>
          <td style={{ textAlign: 'right' }}>
            <NumberFormat
              value={material.balance}
              displayType={'text'}
              thousandSeparator={true}
              decimalScale={2}
              fixedDecimalScale={true}
              style={{
                marginLeft: '5px',
                color: material.balance < 0 ? '#B42A19' : '',
              }}
            />
            <span style={{ marginLeft: '10px' }} className="float-right">
              <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                {material.is_archived === 1 && (
                  <CTooltip content="This material is archived">
                    <span className="ml-4 mr-2">
                      <FaArchive />
                    </span>
                  </CTooltip>
                )}
                {material.remove !== true && (
                  <CDropdown>
                    <CDropdownToggle className="caret">
                      <span className="iconify" data-icon="akar-icons:more-vertical"></span>
                    </CDropdownToggle>
                    <CDropdownMenu>
                      <CDropdownItem header>Action</CDropdownItem>
                      <CDropdownDivider />
                      {checkPermission("/estimate/save") && (
                        <CDropdownItem onClick={() => editMaterial(scopeIndex, Index)}>
                          <span className="iconify" data-icon="bi:pencil-square"></span>
                          <span style={{ marginLeft: '5px' }}>Edit</span>
                        </CDropdownItem>
                      )}
                      {checkPermission("/estimate/save") && (
                        <CDropdownItem onClick={() => removeMaterial(scopeIndex, Index)}>
                          <span className="iconify" data-icon="akar-icons:minus"></span>
                          <span style={{ marginLeft: '5px' }}>Remove</span>
                        </CDropdownItem>
                      )}
                    </CDropdownMenu>
                  </CDropdown>
                )}
              </span>
            </span>
          </td>
        </tr>
      );
    });

    return (
      <>
        <table className={`${tableClass}`} key={Index} style={{ marginTop: '30px', textAlign: 'justify' }}>
          <tbody key={Index} lg="12" xl="12">
            <tr className="table-borderless">
              <td colSpan="12">
                <div className="text-base font-bold">
                  {scope.new != true ? (
                    <div className="flex items-center" id={`phase-${scope.phase_id}`}>
                      <span className="mr-5 text-lg">
                        {props?.order_by === 'Description' ? scope?.tag_name : scope['phase']}
                      </span>
                      {scope.is_sub_con === 1 ? (
                        <CBadge color="aimhi-success" className="badge-stats">
                          Subcontractor
                        </CBadge>
                      ) : (
                        ''
                      )}
                    </div>
                  ) : (
                    <span>
                      Scope Of Work
                      <CreatableSelect
                        styles={phaseCustomStyles}
                        className="md:max-w-[50%]"
                        value={{
                          label: scope['phase'],
                          value: scope['phase'],
                        }}
                        options={phases}
                        onChange={(opt, meta) => phaseonchange(opt, meta, scopeIndex)}
                        isValidNewOption={() => false}
                        isClearable={true}
                      />
                      {scope.isEmptyPhase && <CLabel className="text-[#B42A19]">Scope of work is required.</CLabel>}
                    </span>
                  )}
                </div>
                <div
                  className="text-sm font-bold"
                  id={`sow_id-${scope.sow_id}-psow_id-${scope.psow_id}`}
                >
                  {typeof scope.new == 'undefined' && typeof scope['edit'] == 'undefined' ? (
                    <div className="flex items-center justify-between w-full">
                      <span onClick={() => toggleShow(scope[0])} className="flex-1 cursor-pointer">
                        {scope[0]}
                      </span>
                      <div className="flex gap-2.5 ml-auto">
                        <FaPencilAlt
                          title="Edit Scope of Work"
                          className="cursor-pointer hover:opacity-40"
                          size={18}
                          onClick={() => EditSow(scope.id)}
                        />
                        <FaTrashAlt
                          title="Remove Scope of Work"
                          className="cursor-pointer hover:opacity-40"
                          size={18}
                          onClick={() => RemoveSow(scope.id)}
                        />
                      </div>
                    </div>
                  ) : (
                    <span onClick={() => toggleShow(scope[0])} className="cursor-pointer">
                      Work Item
                      <CreatableSelect
                        styles={sowCustomStyles}
                        className="md:max-w-[50%]"
                        value={{
                          label: scope[0],
                          value: scope[0],
                        }}
                        options={sowOptions[scope['phase_category_id']] || sowOptions[-1] || []}
                        onChange={(opt, meta) => sowonchange(opt, meta, scopeIndex)}
                        onInputChange={(value) => {
                          debouncedFetchOptions(value, scope);
                        }}
                        onBlur={() => {
                          debouncedFetchOptions('', scope);
                        }}
                        isValidNewOption={() => false}
                        isOptionDisabled={(option) => option.disabled}
                        filterOption={null}
                        isClearable={true}
                      />
                      {scope.isEmptyWork && <CLabel className="text-[#B42A19] mb-0">Work item is required.</CLabel>}
                    </span>
                  )}
                </div>

                <div
                  className="relative text-xs font-bold"
                  onClick={() => toggleShow(scope[0])}
                  id={`sow_id-${scope.sow_id}-psow_id-${scope.psow_id}`}
                >
                  {typeof scope.new == 'undefined' && typeof scope['edit'] == 'undefined' ? (
                    <span className="text-sm font-normal cursor-pointer">
                      {props?.order_by === 'Description' ? scope['phase'] : scope?.tag_name}
                    </span>
                  ) : (
                    <div className="position-relative d-flex flex-column" style={{ marginLeft: "30px" }}>
                      <div
                        style={{
                          position: "absolute",
                          left: "-20px",
                          top: "8px",
                          width: "15px",
                          height: "30px",
                          borderLeft: "2px solid rgba(0,0,0,0.2)",
                          borderBottom: "2px solid rgba(0,0,0,0.2)",
                        }}
                      ></div>
                      <p className="my-1 font-bold font-italic">
                        Work Item Description (Optional)
                      </p>
                      <CreatableSelect
                        value={{
                          value: scope?.company_tag_id || "",
                          label: scope?.tag_name || "",
                        }}
                        className="md:max-w-[48.7%]"
                        options={workItemDescriptionList}
                        onChange={(opt) => workItemDescriptionChange(opt, scopeIndex)}
                        onCreateOption={(e) => handleCreateWorkItemDescription(e, scopeIndex)}
                        isClearable={true}
                      />
                    </div>
                  )}
                </div>
                <div
                  className="font-bold text-base mt-2.5"
                  onClick={() => toggleShow(scope[0])}
                >
                  {scope.new != true && scope.edit != true ? (
                    ''
                  ) : (
                    <span className="cursor-pointer">
                      Contractor Type
                      <CSelect
                        value={scope.is_sub_con}
                        size="md"
                        className="pl-2 font-bold text-base font-roboto text-[#333333] md:max-w-[49.7%]"
                        onChange={(opt) => workTypeOnChange(opt, scopeIndex)}
                      >
                        <option value="0">General contractor</option>
                        <option value="1">Subcontractor</option>
                      </CSelect>
                    </span>
                  )}
                </div>

                <div
                  className="font-bold text-base mt-2.5"
                  onClick={() => toggleShow(scope[0])}
                >
                  {scope.new != true && scope.edit != true ? (
                    <div className="cursor-pointer">
                      {scope.unit_id ? `${scope.measurement} ${units[scope.unit_id]}` : null}
                    </div>
                  ) : (
                    <span className="cursor-pointer">
                      Measurement
                      <div className="flex items-center gap-0">
                        <CInput
                          type="number"
                          className={`rounded-l-md md:!w-[40%] ${scope.isEmptyMeasurement ? 'border-[#B42A19]' : 'border-[#757070]'}`}
                          value={scope.measurement}
                          onChange={(e) => areaOrVolumeOnChange(e.target.value, scopeIndex)}
                          onKeyDown={preventInvalidKeys}
                          onWheel={blurOnWheel}
                          onPaste={preventInvalidPaste}
                        />
                        <CSelect
                          value={scope.unit_id}
                          className="md:!w-[10%] rounded-r-md text-[#22303d] border-[#757070] bg-[#f4f4f7]"
                          onChange={(opt) => areaORVolumeUnitOnChange(opt.target.value, scopeIndex)}
                        >
                          {Object.keys(units).map((unitId) => (
                            <option key={`unit-key-${unitId}`} value={unitId}>
                              {units[unitId]}
                            </option>
                          ))}
                        </CSelect>
                      </div>
                      {scope.isEmptyMeasurement && <CLabel className="text-[#B42A19]">Measurement is required.</CLabel>}
                    </span>
                  )}
                </div>
              </td>
            </tr>

            <tr>
              <td colSpan="12" className={`relative py-2 mt-0 ${scope.edit || scope.new ? '!border-t-0' : ''} `}>
                <div className="flex justify-end">
                  <a
                    onClick={() => {
                      toggleOptions(Index);
                    }}
                    className="text-[#39f] underline cursor-pointer expand-collapse"
                  >
                    <strong className='text-sm'>{showOptions[Index] ? 'COLLAPSE' : 'EXPAND'}</strong>
                  </a>
                </div>
              </td>
            </tr>

            {showOptions[Index] && (
              <>
                <tr className="text-center bg-[#F4F4F7] font-semibold text-sm border-0">
                  <td className="w-[400px]">Designation</td>
                  <td>
                    Estimated <br></br>Workers
                  </td>

                  <td>Duration</td>
                  <td className="text-right">Rate</td>
                  <td className="text-right">
                    Estimated <br></br>Cost
                  </td>
                  <td>
                    Hired <br></br>Workers
                  </td>

                  <CTooltip content="Click to update the total labor actual cost." placement="right-end" color="white">
                    <td
                      onClick={() => scrollToElement('#target-section')}
                      role="button"
                      tabIndex={0}
                      className="cursor-pointer"
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') scrollToElement('#target-section');
                      }}
                    >
                      Actual <br /> Cost
                    </td>
                  </CTooltip>

                  <td>Balance</td>
                </tr>
                <tr className="text-base font-semibold">
                  <td colSpan="4">Labor</td>
                  <td colSpan="1" className="text-right">
                    <NumberFormat
                      value={scope?.total_estimated_labor_cost}
                      displayType={'text'}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      className="ml-1.5"
                    />
                  </td>
                  <td colSpan="1"></td>

                  {scope['edit_labor_cost'] == true ? (
                    <td colSpan="1" className="bg-[#5497613d]">
                      <CInput
                        type="number"
                        size="md"
                        onChange={(e) => LaborTotalOnchange(e, Index)}
                        value={scope?.total_actual_labor_cost_subcon}
                        onKeyDown={preventInvalidKeys}
                        onWheel={blurOnWheel}
                        onPaste={preventInvalidPaste}
                      />
                    </td>
                  ) : (
                    <td className="text-right bg-[#5497613d]">
                      <span>
                        <NumberFormat
                          value={scope?.total_actual_labor_cost_subcon}
                          displayType={'text'}
                          thousandSeparator={true}
                          decimalScale={2}
                          fixedDecimalScale={true}
                          className="ml-1.5"
                        />
                      </span>
                      <span className="ml-1.5">
                        {checkPermission("/estimate/save") && scope.is_sub_con === 1 && (
                          <FaPencilAlt
                            onClick={() => editLaborTotal(Index)}
                            className="h-3.5 w-3.5 cursor-pointer inline"
                          />
                        )}
                      </span>
                    </td>
                  )}

                  <td colSpan="1" className="text-right">
                    <NumberFormat
                      value={scope.labor_balance}
                      displayType={'text'}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      className={`ml-1.5 ${scope.labor_balance < 0 ? 'text-[#B42A19]' : ''}`}
                    />
                    <span className="ml-2.5 float-right">
                      <CDropdown>
                        <CDropdownToggle className="caret">
                          <span className="iconify" data-icon="akar-icons:more-vertical"></span>
                        </CDropdownToggle>
                        <CDropdownMenu>
                          <CDropdownItem header>Action</CDropdownItem>
                          <CDropdownDivider />

                          <CDropdownItem onClick={() => AddNew(scopeIndex, 'Labor', Index)}>
                            <span className="iconify" data-icon="ant-design:plus-outlined"></span>
                            Add New
                          </CDropdownItem>
                        </CDropdownMenu>
                      </CDropdown>
                    </span>
                  </td>
                </tr>
                {togglescope.includes(scope[0] + 'Labor' + Index) || (show == true && Labor)}

                <tr className="text-center bg-[#F4F4F7] font-semibold text-sm">
                  <td>Description</td>
                  <td>
                    Estimated <br></br>Quantity
                  </td>

                  <td>Duration</td>
                  <td className="text-right">Rate</td>
                  <td className="text-right">
                    Estimated <br></br>Cost
                  </td>

                  <td>
                    Ordered <br></br> Quantity
                  </td>

                  <CTooltip content="Click to update the total equipment actual cost." placement="right-end" color="white">
                    <td
                      onClick={() => scrollToElement('#target-section')}
                      role="button"
                      tabIndex={0}
                      className="cursor-pointer"
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') scrollToElement('#target-section');
                      }}
                    >
                      Actual <br /> Cost
                    </td>
                  </CTooltip>
                  <td>Balance</td>
                </tr>
                <tr className="text-base font-semibold">
                  <td colSpan="4">Equipment</td>
                  <td colSpan="1" className="text-right">
                    <NumberFormat
                      value={scope.total_estimated_equipment_cost}
                      displayType={'text'}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      className="ml-1.5"
                    />
                  </td>
                  <td colSpan="1"></td>

                  {scope['edit_equipment_cost'] == true ? (
                    <td colSpan="1" className="bg-[#5497613d]">
                      <CInput
                        type="number"
                        size="md"
                        onChange={(e) => EquipmentTotalChange(e, Index)}
                        value={scope.total_actual_equipment_cost_subcon}
                      />
                    </td>
                  ) : (
                    <td className="text-right bg-[#5497613d]">
                      <span>
                        <NumberFormat
                          value={scope.total_actual_equipment_cost_subcon}
                          displayType={'text'}
                          thousandSeparator={true}
                          decimalScale={2}
                          fixedDecimalScale={true}
                          className="ml-1.5"
                        />
                      </span>
                      <span className="ml-1.5">
                        {checkPermission("/estimate/save") && scope.is_sub_con === 1 && (
                          <FaPencilAlt
                            onClick={() => editEquipmentTotal(Index)}
                            className="h-3.5 w-3.5 cursor-pointer inline"
                          />
                        )}
                      </span>
                    </td>
                  )}
                  <td colSpan="1" className="text-right">
                    <NumberFormat
                      value={scope.total_equipment_balance}
                      displayType={'text'}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      className={`ml-1.5 ${scope.total_equipment_balance < 0 ? 'text-[#B42A19]' : ''}`}
                    />
                    <span className="ml-2.5 float-right">
                      <CDropdown>
                        <CDropdownToggle className="caret">
                          <span className="iconify" data-icon="akar-icons:more-vertical"></span>
                        </CDropdownToggle>
                        <CDropdownMenu>
                          <CDropdownItem header>Action</CDropdownItem>
                          <CDropdownDivider />
                          <CDropdownItem onClick={() => AddNew(scopeIndex, 'Equipment')}>
                            <span className="iconify" data-icon="ant-design:plus-outlined"></span>
                            Add New
                          </CDropdownItem>
                        </CDropdownMenu>
                      </CDropdown>
                    </span>
                  </td>
                </tr>
                {togglescope.includes(scope[0] + 'Equipment' + Index) || (show == true && Equipment)}

                <tr className="text-center bg-[#F4F4F7] font-semibold text-sm">
                  <td>Description</td>
                  <td>
                    Estimated <br></br>Quantity
                  </td>

                  <td>Unit</td>
                  <td className="text-right">Unit Cost</td>
                  <td className="text-right">
                    Estimated <br></br> Cost
                  </td>
                  <td>
                    Ordered <br></br> Quantity
                  </td>

                  <td>
                    Actual <br></br>Cost
                  </td>
                  <td>Balance</td>
                </tr>
                <tr className="text-base font-semibold">
                  <td colSpan="4">Material</td>
                  <td colSpan="1" className="text-right">
                    <NumberFormat
                      value={scope.total_estimated_material_cost}
                      displayType={'text'}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      className="ml-1.5"
                    />
                  </td>
                  <td colSpan="1"></td>
                  <td colSpan="1" className="text-right bg-[#5497613d]">
                    <NumberFormat
                      value={scope.total_actual_material_cost}
                      displayType={'text'}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      className="ml-1.5"
                    />
                  </td>
                  <td colSpan="1" className="text-right">
                    <NumberFormat
                      value={scope.total_material_balance}
                      displayType={'text'}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      className="ml-1.5"
                    />
                    <span className="ml-2.5 float-right">
                      <CDropdown>
                        <CDropdownToggle className="caret">
                          <span className="iconify" data-icon="akar-icons:more-vertical"></span>
                        </CDropdownToggle>
                        <CDropdownMenu>
                          <CDropdownItem header>Action</CDropdownItem>
                          <CDropdownDivider />
                          <CDropdownItem onClick={() => AddNew(scopeIndex, 'Material')}>
                            <span className="iconify" data-icon="ant-design:plus-outlined"></span>
                            Add New
                          </CDropdownItem>
                        </CDropdownMenu>
                      </CDropdown>
                    </span>
                  </td>
                </tr>
                {togglescope.includes(scope[0] + 'Material' + Index) || (show == true && Material)}
                <tr>
                  <td colSpan={8}></td>
                </tr>
              </>
            )}

            <div className={showOptions[Index] ? '' : '-mt-[75px]'}></div>
            <tr className="text-sm">
              <td colSpan="4">Labor</td>
              <td colSpan="1" className="text-right">
                <NumberFormat
                  value={scope.total_estimated_labor_cost}
                  displayType={'text'}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  className="ml-1.5"
                />
              </td>
              <td colSpan="1"></td>
              <td colSpan="1" className="text-right bg-[#5497613d]">
                <NumberFormat
                  value={scope.total_actual_labor_cost}
                  displayType={'text'}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  className="ml-1.5"
                />
              </td>
              <td colSpan="1" className="text-right">
                <NumberFormat
                  value={scope.total_labor_balance}
                  displayType={'text'}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  className={`ml-1.5 ${scope.total_labor_balance < 0 ? 'text-[#B42A19]' : ''}`}
                />
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;</span>
              </td>
            </tr>

            <tr className="text-sm table-borderless">
              <td colSpan="4">Equipment</td>
              <td colSpan="1" className="text-right">
                <NumberFormat
                  value={scope.total_estimated_equipment_cost}
                  displayType={'text'}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  className="ml-1.5"
                />
              </td>
              <td colSpan="1"></td>
              <td colSpan="1" className="text-right bg-[#5497613d]">
                <NumberFormat
                  value={scope.total_actual_equipment_cost}
                  displayType={'text'}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  className="ml-1.5"
                />
              </td>
              <td colSpan="1" className="text-right">
                <NumberFormat
                  value={scope.total_equipment_balance}
                  displayType={'text'}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  className={`ml-1.5 ${scope.total_equipment_balance < 0 ? 'text-[#B42A19]' : ''}`}
                />
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;</span>
              </td>
            </tr>

            <tr className="text-sm table-borderless">
              <td colSpan="4">Material</td>

              <td className="text-right table-borderless" colSpan="1">
                <NumberFormat
                  value={scope.total_estimated_material_cost}
                  displayType={'text'}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  className="ml-1.5"
                />
              </td>
              <td colSpan="1"></td>
              <td colSpan="1" className="text-right bg-[#5497613d]">
                <NumberFormat
                  value={scope.total_actual_material_cost}
                  displayType={'text'}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  className="ml-1.5"
                />
              </td>
              <td colSpan="1" className="text-right">
                <NumberFormat
                  value={scope.total_material_balance}
                  displayType={'text'}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  className={`ml-1.5 ${scope.total_material_balancee < 0 ? 'text-[#B42A19]' : ''}`}
                />
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;</span>
              </td>
            </tr>

            <tr className="text-sm">
              <td colSpan="4">
                <CTooltip content="Total Direct Cost = Labor Cost + Equipment Cost + Material Cost" placement="right-end" color="white">
                  <span>
                    Total Direct Cost
                    <FaRegQuestionCircle className="w-3.5 h-3.5 ml-1.5 text-[#757070] inline" />
                  </span>
                </CTooltip>
              </td>

              <td colSpan="1" className="text-right">
                ₱
                <NumberFormat
                  value={scope.estimated_total_direct_cost}
                  displayType={'text'}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  className="ml-1.5"
                />
              </td>
              <td colSpan="1"></td>
              <td colSpan="1" className="text-right bg-[#5497613d]">
                ₱
                <NumberFormat
                  value={scope.actual_total_direct_cost}
                  displayType={'text'}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  className="ml-1.5"
                />
              </td>
              <td colSpan="1" className="text-right">
                ₱
                <NumberFormat
                  value={scope.total_direct_cost_balance}
                  displayType={'text'}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  className={`ml-1.5 ${scope.total_direct_cost_balance < 0 ? 'text-[#B42A19]' : ''}`}
                />
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;</span>
              </td>
            </tr>
            <tr className="table-borderless">
              <td colSpan="8"></td>
            </tr>

            <tr className="text-sm table-borderless">
              <td colSpan="4">
                <CTooltip content={`Overhead, contingencies, and miscellaneous = ${grantTotal?.ocm_percentage}% of Actual Direct Cost`} placement="right-end" color="white">
                  <span>
                    OCM
                    <FaRegQuestionCircle className="w-3.5 h-3.5 ml-1.5 text-[#757070] inline" />
                  </span>
                </CTooltip>
              </td>

              <td colSpan="1" className="text-right">
                <NumberFormat
                  value={scope.estimated_ocm}
                  displayType={'text'}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  className="ml-1.5"
                />
              </td>
              <td colSpan="1"></td>
              <td colSpan="1" className="text-right bg-[#5497613d]">
                <NumberFormat
                  value={scope.actual_ocm}
                  displayType={'text'}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  className="ml-1.5"
                />
              </td>
              <td colSpan="1" className="text-right">
                <NumberFormat
                  value={scope.ocm_balance}
                  displayType={'text'}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  className={`ml-1.5 ${scope.ocm_balance < 0 ? 'text-[#B42A19]' : ''}`}
                />
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;</span>
              </td>
            </tr>
            {hasVAT != 2 && (
              <tr className="text-sm table-borderless">
                <td colSpan="4">
                  <CTooltip content={`Value Added Tax = ${grantTotal?.vat_value ? grantTotal?.vat_value * 100 : 0}% of (Actual Direct Cost + OCM + CP)`} placement="right-end" color="white">
                    <span>
                      VAT
                      <FaRegQuestionCircle className="w-3.5 h-3.5 ml-1.5 text-[#757070] inline" />
                    </span>
                  </CTooltip>
                </td>

                <td colSpan="1" className="text-right">
                  <NumberFormat
                    value={scope.estimated_vat}
                    displayType={'text'}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    className="ml-1.5"
                  />
                </td>
                <td colSpan="1"></td>
                <td colSpan="1" className="text-right bg-[#5497613d]">
                  <NumberFormat
                    value={scope.actual_vat}
                    displayType={'text'}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    className="ml-1.5"
                  />
                </td>
                <td colSpan="1" className="text-right">
                  <NumberFormat
                    value={scope.vat_balance}
                    displayType={'text'}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    className={`ml-1.5 ${scope.vat_balance < 0 ? 'text-[#B42A19]' : ''}`}
                  />
                  <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;</span>
                </td>
              </tr>
            )}

            <tr className="text-sm table-borderless">
              <td colSpan="4">
                <CTooltip content={`Contractor's Profit = ${grantTotal?.cp_percenteage}% of Actual Direct Cost`} placement="right-end" color="white">
                  <span>
                    CP
                    <FaRegQuestionCircle className="w-3.5 h-3.5 ml-1.5 text-[#757070] inline" />
                  </span>
                </CTooltip>
              </td>

              <td colSpan="1" className="text-right">
                <NumberFormat
                  value={scope.estimated_cp}
                  displayType={'text'}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  className="ml-1.5"
                />
              </td>
              <td colSpan="1"></td>
              <td colSpan="1" className="text-right bg-[#5497613d]">
                <NumberFormat
                  value={scope.actual_cp}
                  displayType={'text'}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  className="ml-1.5"
                />
              </td>
              <td colSpan="1" className="text-right">
                <NumberFormat
                  value={scope.cp_balance}
                  displayType={'text'}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  className={`ml-1.5 ${scope.cp_balance < 0 ? 'text-[#B42A19]' : ''}`}
                />
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;</span>
              </td>
            </tr>

            <tr className="text-sm">
              <td colSpan="4">
                <CTooltip content="Indirect Cost = OCM + CP + VAT" placement="right-end" color="white">
                  <span>
                    Total Indirect Cost
                    <FaRegQuestionCircle className="w-3.5 h-3.5 ml-1.5 text-[#757070] inline" />
                  </span>
                </CTooltip>
              </td>

              <td colSpan="1" className="text-right">
                ₱
                <NumberFormat
                  value={scope.estimated_total_indirect_cost}
                  displayType={'text'}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  className="ml-1.5"
                />
              </td>
              <td colSpan="1"></td>
              <td colSpan="1" className="text-right bg-[#5497613d]">
                ₱
                <NumberFormat
                  value={scope.actual_total_indirect_cost}
                  displayType={'text'}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  className="ml-1.5"
                />
              </td>
              <td colSpan="1" className="text-right">
                ₱
                <NumberFormat
                  value={scope.total_indirect_cost_balance}
                  displayType={'text'}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  className={`ml-1.5 ${scope.total_indirect_cost_balance < 0 ? 'text-[#B42A19]' : ''}`}
                />
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;</span>
              </td>
            </tr>

            <tr className="text-sm table-borderless">
              <td colSpan="4">
                <CTooltip content=" Contract Cost = Actual Direct Cost + Indirect Cost" placement="right-end" color="white">
                  <span>
                    Total Contract Cost
                    <FaRegQuestionCircle className="w-3.5 h-3.5 ml-1.5 text-[#757070] inline" />
                  </span>
                </CTooltip>
              </td>

              <td colSpan="1" className="text-right">
                ₱
                <NumberFormat
                  value={scope.estimated_total_contract_cost}
                  displayType={'text'}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  className="ml-1.5"
                />
              </td>
              <td colSpan="1"></td>
              <td colSpan="1" className="text-right bg-[#5497613d]">
                ₱
                <NumberFormat
                  value={scope.actual_total_contract_cost}
                  displayType={'text'}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  className="ml-1.5"
                />
              </td>
              <td colSpan="1" className="text-right">
                ₱
                <NumberFormat
                  value={scope.total_contract_cost_balance}
                  displayType={'text'}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  className={`ml-1.5 ${scope.total_contract_cost_balance < 0 ? 'text-[#B42A19]' : ''}`}
                />
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;</span>
              </td>
            </tr>

            <tr className="table-borderless">
              <td> </td>
            </tr>
            <tr className="table-borderless">
              <td> </td>
            </tr>
            <tr>
              <td colSpan="8" className="border-b-[5px] border-b-[#549764] border-t border-t-white"></td>
            </tr>
          </tbody>
        </table>
      </>
    );
  });

  const updateItems = (data, index, checked) => {

    const updateItem = (item) => {
      if (item.new || item.edit || item.remove) {
        item.is_variance_order = checked;
      }
    };

    const updateList = (list) => {
      if (list && list.length > 0) {
        list.forEach(updateItem);
      }
    };

    const laborList = data[index].labor ? data[index].labor : data.labor;
    const equipmentList = data[index].equipment ? data[index].equipment : data.equipment;
    const materialList = data[index].material ? data[index].material : data.material;

    updateList(laborList);
    updateList(equipmentList);
    updateList(materialList);
  };

  const handleCheckboxChange = (props) => {
    let data = [...varianceOrderData];
    updateItems(data, props.Index, props.checked);
    setVarianceOrderData(data);
  };

  const varianceOrderAction = (checked) => {
    let data = [...varianceOrderData];
    updateItems(data, 0, checked);
    setVarianceOrderData(data);
    SaveSow(2, varianceOrderData);
    setModalVarianceOrder(!modalVarianceOrder);
  };

  const varianceOrderSubmit = () => {
    let data = [...varianceOrderData];

    const filteredData = data.filter((item) => {
      const hasVarianceOrderInArray = (array) => array?.some((element) => element.is_variance_order && (element.new || element.edit));

      return !hasVarianceOrderInArray(item.labor) && !hasVarianceOrderInArray(item.equipment) && !hasVarianceOrderInArray(item.material);
    });

    if (filteredData) {
      filteredData.forEach((item) => {
        updateItems(item, 0, false);
      });
    }

    SaveSow(2, varianceOrderData);
    setModalVarianceOrder(!modalVarianceOrder);
  };

  const varianceOrderYes = () => {
    varianceOrderAction(true);
  };

  const varianceOrderNo = () => {
    varianceOrderAction(false);
  };

  const varianceOrderPreview = varianceOrderData.map((data, Index) => {
    const hasActiveLabor = data.labor?.some((l) => (l.new || l.edit) && !l.remove);
    const hasActiveEquipment = data.equipment?.some((e) => (e.new || e.edit) && !e.remove);
    const hasActiveMaterial = data.material?.some((m) => (m.new || m.edit) && !m.remove);
    if (!hasActiveLabor && !hasActiveEquipment && !hasActiveMaterial) {
      return null;
    }

    const labor = data.labor.map((labor, Index) => {
      if ((labor.new || labor.edit) && !labor.remove) {
        return (
          <tr
            style={{
              textAlign: 'center',
              backgroundColor: labor.new || labor.edit ? '#5abc6d' : '#e8786a',
            }}
            key={Index}
          >
            <td>{labor.designation}</td>
            <td>{labor.estimated_workers}</td>
            <td>{labor.duration}</td>
            <td>{labor.rate}</td>
            <td>{labor.estimated_cost}</td>
            <td>{labor.hired_workers}</td>
            <td>{labor.actual_cost}</td>
            <td>{labor.balance}</td>
          </tr>
        );
      }
    });

    const equipment = data.equipment.map((equipment, Index) => {
      if ((equipment.new || equipment.edit) && !equipment.remove) {
        return (
          <tr
            style={{
              textAlign: 'center',
              backgroundColor: equipment.new || equipment.edit ? '#5abc6d' : '#e8786a',
            }}
            key={Index}
          >
            <td>{equipment.description}</td>
            <td>{equipment.estimated_quantity}</td>
            <td>{equipment.duration}</td>
            <td>{equipment.rate}</td>
            <td>{equipment.estimated_cost}</td>
            <td>{equipment.ordered_quantity}</td>
            <td>{equipment.actual_cost}</td>
            <td>{equipment.balance}</td>
          </tr>
        );
      }
    });

    const material = data.material.map((material, Index) => {
      if ((material.new || material.edit) && !material.remove) {
        return (
          <tr
            style={{
              textAlign: 'center',
              backgroundColor: material.new || material.edit ? '#5abc6d' : '#e8786a',
            }}
            key={Index}
          >
            <td>{material.description}</td>
            <td>{material.estimated_quantity}</td>
            <td>{material.unit}</td>
            <td>{material.unit_cost}</td>
            <td>{material.estimated_cost}</td>
            <td>{material.ordered_quantity}</td>
            <td>{material.actual_cost}</td>
            <td>{material.balance}</td>
          </tr>
        );
      }
    });

    return (
      <tbody key={Index}>
        <tr
          className="table-borderless"
          style={{
            fontWeight: '600',
            fontSize: '16px',
          }}
        >
          <td colSpan={8} style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', width: '100%' }}>
            <span style={{ marginRight: '10px', whiteSpace: 'nowrap' }}>{data.phase}</span> {varianceOrderData.length > 1 && <input type="checkbox" style={{ width: '20px', height: '20px' }} onChange={(e) => handleCheckboxChange({ Index, checked: e.target.checked })} />}
          </td>
        </tr>
        <tr
          className="table-borderless"
          style={{
            fontWeight: '600',
            fontSize: '16px',
          }}
        >
          <td colSpan={8}>{data[0]}</td>
        </tr>
        <tr
          style={{
            background: '#F4F4F7',
            fontWeight: '600',
            fontSize: '14px',
          }}
        >
          <td style={{ width: '200px', textAlign: 'center' }}>Designation</td>
          <td>Estimated Workers</td>
          <td>Duration</td>
          <td>Rate</td>
          <td>Estimated Cost</td>
          <td>Hired Workers </td>
          <td>Actual Cost</td>
          <td>Balance</td>
        </tr>
        <tr style={{ backgroundColor: data?.edit_labor_cost ? '#5abc6d' : 'transparent', }}>
          <td colSpan={1} style={{ textAlign: 'left', fontWeight: '600', fontSize: '16px', padding: '10px' }}>
            Labor
          </td>
          {
            Array.from({ length: 5 }).map((_, index) => (
              <td key={index}></td>
            )
            )}
          <td>
            {data?.edit_labor_cost ? data?.total_actual_labor_cost_subcon : ''}
          </td>
          <td></td>
        </tr>

        {labor}
        <tr
          style={{
            background: '#F4F4F7',
            fontWeight: '600',
            fontSize: '14px',
          }}
        >
          <td style={{ width: '200px', textAlign: 'center' }}>Description</td>
          <td>Estimated Quantity</td>
          <td>Duration</td>
          <td>Rate</td>
          <td>Estimated Cost</td>
          <td>Ordered Quantity </td>
          <td>Actual Cost</td>
          <td>Balance</td>
        </tr>
        <tr style={{ backgroundColor: data?.edit_equipment_cost ? '#5abc6d' : 'transparent', }}>
          <td colSpan={1} style={{ textAlign: 'left', fontWeight: '600', fontSize: '16px' }}>
            Equipment
          </td>
          {
            Array.from({ length: 5 }).map((_, index) => (
              <td key={index}></td>
            )
            )}
          <td>
            {data?.edit_equipment_cost ? data?.total_actual_equipment_cost_subcon : ''}
          </td>
          <td></td>
        </tr>
        {equipment}
        <tr
          style={{
            background: '#F4F4F7',
            fontWeight: '600',
            fontSize: '14px',
          }}
        >
          <td style={{ width: '200px', textAlign: 'center' }}>Description</td>
          <td>Estimated Quantity</td>
          <td>Unit</td>
          <td>Unit Cost</td>
          <td>Estimated Cost</td>
          <td>Ordered Quantity </td>
          <td>Actual Cost</td>
          <td>Balance</td>
        </tr>
        <tr>
          <td colSpan={8} style={{ textAlign: 'left', fontWeight: '600', fontSize: '16px' }}>
            Material
          </td>
        </tr>
        {material}
      </tbody>
    );
  });

  const handleDownload = async (project_id, type, closeDialog) => {
    setIsLoading(true);
    const { balance, status } = await refreshSubscription();
    const handleDownloadReport = async () => {
      await DownloadReport(project_id, type)
        .then(() => {
          trackEvent(type === 1 || type === 8 ? mixPanelEvents.DOWNLOAD_DETAILED_ESTIMATE : type === 2 ? mixPanelEvents.DOWNLOAD_BOM : mixPanelEvents.DOWNLOAD_BOQ, {
            'Source': 'Project - Estimate',
          })
          setIsLoading(false);
          closeDialog();
        })
        .catch((error) => {
          if (error?.response?.status === 403) {
            showError(error?.response?.data?.response, "Permission Denied");
            return;
          }
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error,
            confirmButtonColor: '#23303D',
          });
          setIsLoading(false);
        });
    }

    if (status === 0) {
      if (balance != null && +balance < 15) return (setIsLoading(false), NoCreditsLeft());
      openDialog({
        title: 'Power Tool Feature',
        message: `You have ${balance} credits. Get unlimited Power Tools for P250/month or pay P15 per use. Once you use your credits, there’s no going back—no refunds or changes. Are you sure you want to continue? If so, how would you like to proceed?`,
        onPrimaryAction: handleDownloadReport,
        primaryActionText: 'Pay P15',
        onSecondaryAction: () => handleSubscriptionRequest().then((res) => res === 1 && handleDownloadReport()).finally(() => setIsLoading(false)),
        secondaryActionText: 'Subscribe for P250',
        iconType: 'info',
        iconColor: '#3B74BE',
        onClose: () => setIsLoading(false),
      });
    }
    else {
      handleDownloadReport();
    }
  };

  const toggleLaborGrantTotalEditMode = () => {
    setLaborGrantTotalEditing(true);
  };
  const toggleEquipmentGrantTotalEditMode = () => {
    setEquipmentGrantTotalEditing(true);
  };

  const handleLaborGrantTotalChange = (values) => {
    const { floatValue } = values;
    setIsTotalActualCostEdited(true);
    setgrantTotal((prev) => ({ ...prev, total_actual_labor_cost: floatValue }));
  };
  const handleEquipmentGrantTotalChange = (values) => {
    const { floatValue } = values;
    setIsTotalActualCostEdited(true);
    setgrantTotal((prev) => ({ ...prev, total_actual_equipment_cost: floatValue }));
  };

  const handleLaborGrantTotalBlur = () => {
    setLaborGrantTotalEditing(false);
  };
  const handleEquipmentGrantTotalBlur = () => {
    setEquipmentGrantTotalEditing(false);
  };

  const handleImportEstimate = () => setShowEstimateUpload(true);

  return (
    <>
      {loading ? <Loading /> : ''}
      <ProjectTabs />
      {isEstimateRecoToolAllowed && (
        <RiskCalculator
          units={units ?? {}}
          isOpen={isCalculatorOpen}
          title={calculatorTitle}
          sow={calculatorSow}
          work_item={calculatorWorkItem}
          EstWorkers={EstWorkers}
          durationOnchange={durationOnchange}
          index={index}
          scopeIndex={sowIndex}
          toggleCalculator={toggleCalculator}
          materialName={materialName}
          qtyonchange={qtyonchange}
          eqdurationonchange={eqdurationonchange}
          laborProductivity={laborProductivity}
          equipmentProductivity={equipmentProductivity}
          isSowAdded={isSowAdded}
          updateIsSowAdded={updateIsSowAdded}
          setCalculatorStatus={setCalculatorStatus}
          projectID={projectID}
          materialQuantity={materialQuantity}
          matquantityonchange={matquantityonchange}
          areaOrVolumeOnChange={areaOrVolumeOnChange}
          areaOrVolumeUnitOnChange={areaORVolumeUnitOnChange}
        />
      )}
      <CRow className="table-size">
        <CCol xs="12" sm="12" md="12" lg="12">
          <CCol xs="12" sm="12" md="12" lg="12" style={{ marginTop: '20px', padding: '0px' }}>
            <CRow>
              <CCol xl="6">
                <label class="form-label" for="exampleDataList">
                  Search
                </label>
                <input
                  type="search"
                  class="form-control"
                  id="exampleDataList"
                  list="datalistOptions"
                  placeholder="Type scope of work to search..."
                  onChange={(e) => {
                    debouncedSearchSow(e.target.value);
                  }}
                />
                <datalist id="datalistOptions">{sowOptionSearch}</datalist>
              </CCol>
              <CCol xl="6">
                <CCol lg="12" style={{ textAlign: 'right', fontSize: '12px' }}>
                  <span>
                    Last edit was made {dateUpdated} by {updatedBy}
                  </span>
                </CCol>
                <CCol lg="12" style={{ textAlign: 'right', fontSize: '12px' }}>
                  <span>Status: {projectInfo?.estimate_status == 1 ? 'Drafted' : 'Submitted'}</span>
                </CCol>
              </CCol>
            </CRow>

            <CCol lg="12" style={{ marginTop: '10px' }}></CCol>
            <CRow className="align-items-start justify-content-between">
              <CCol md="6" lg="6">
                {(checkPermission("/estimate/save")) && (
                  <CRow>
                    {!featuresFlags?.estimateImporter && (
                      <>
                        <CCol md="4" className="mb-2">
                          <CButton color="aimhi-textlight-neutral" size="sm" block variant="outline" onClick={handleImportEstimate}>
                            Import Estimate
                          </CButton>
                        </CCol>
                      </>
                    )}
                    <CCol md="4" className="mb-2">
                      <CButton color="aimhi-textlight-neutral" size="sm" block variant="outline" onClick={AddSow}>
                        Add
                      </CButton>
                    </CCol>
                  </CRow>
                )}
              </CCol>

              <CCol className="ms-auto">
                <CRow className="justify-content-end">
                  <CCol md="4" className="mb-2">
                    {checkPermission("/estimate/save") && isDownloadableReportAllowed && (
                      <CDropdown>
                        <CDropdownToggle
                          block
                          color="aimhi-textlight-neutral"
                          variant="outline"
                          size="sm"
                          disabled={
                            dupadata.length <= 0 ||
                            dupadata.some((item) =>
                              Object.entries(item).some(([key, value]) => key !== 'tag_name' && value === '')
                            )
                          }
                        >
                          {isLoading ? (
                            <>
                              <CSpinner color="#23303D" size="sm" /> Download
                            </>
                          ) : (
                            'Download'
                          )}
                        </CDropdownToggle>
                        <CDropdownMenu block size="sm">
                          <CDropdownItem onClick={() => handleDownload(projectID, props?.order_by ? props.order_by === 'Detail' ? 1 : 8 : 1, closeDialog)}>
                            Detailed Estimate
                          </CDropdownItem>
                          <CDropdownItem onClick={() => handleDownload(projectID, 2, closeDialog)}>BOM</CDropdownItem>
                          <CDropdownItem onClick={() => handleDownload(projectID, 3, closeDialog)}>BOQ</CDropdownItem >
                        </CDropdownMenu>
                      </CDropdown>
                    )}
                  </CCol>

                  <CCol md="4" className="mb-2">
                    {checkPermission("/estimate/save") && (
                      <>
                        {estimateStatus == 2 ? (
                          <CButton color="aimhi-textlight-neutral" size="sm" block onClick={checkVarianceOrder}>
                            Save Edited
                          </CButton>
                        ) : (
                          <CDropdown>
                            <CDropdownToggle block color="aimhi-textlight-neutral" size="sm">
                              Save as
                            </CDropdownToggle>
                            <CDropdownMenu>
                              <CDropdownItem onClick={() => SaveSow(1)}>Save as draft</CDropdownItem>
                              <CDropdownItem onClick={() => SaveSow(2)}>Save as submitted</CDropdownItem>
                            </CDropdownMenu>
                          </CDropdown>
                        )}
                      </>
                    )}
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCol>
          <div className='overflow-y-auto max-h-[calc(100vh-250px)]'>
            {searchLoading ? (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '500px' }}>
                <CSpinner style={{ width: '4rem', height: '4rem' }} variant="grow" />{' '}
                <CLabel className="h2" style={{ marginLeft: '10px', marginTop: '12px' }}>
                  Loading...
                </CLabel>
              </div>
            ) : (
              <>
                {printEstimate == false && tbody}
                {dupadata.length == 0 && (
                  <div style={{ textAlign: 'center', marginTop: '200px', height: '500px' }}>
                    <CLabel className="h2"> No data found!</CLabel>
                  </div>
                )}
                {dupadata.length != 0 && (
                  <table
                    className="table table-sm"
                    style={{
                      marginTop: '40px',
                      textAlign: 'justify',
                      fontWeight: 'bold',
                      fontSize: '15px',
                    }}
                  >
                    <tr style={{ textAlign: 'right' }}>
                      <th colSpan="4"></th>
                      <th>Estimated Cost</th>
                      <th colSpan="1"></th>
                      <th>Actual Cost</th>
                      <th>Balance</th>
                    </tr>
                    {errorhandling == false && (
                      <tbody id="target-section">
                        <tr className="table-borderless" style={{ fontSize: '14px' }}>
                          <td colSpan="4">Total Variance Order of Labor </td>

                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat value={grantTotal?.total_estimated_labor_cost_vo} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                          </td>
                          <td colSpan="1"></td>

                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat value={grantTotal?.total_actual_labor_cost_vo} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                          </td>

                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat
                              value={grantTotal?.total_labor_balance_vo}
                              displayType={'text'}
                              thousandSeparator={true}
                              decimalScale={2}
                              fixedDecimalScale={true}
                              style={{
                                marginLeft: '5px',
                                color: grantTotal?.total_labor_balance_vo < 0 ? '#B42A19' : '',
                              }}
                            />
                          </td>
                        </tr>
                        <tr className="table-borderless" style={{ fontSize: '14px' }}>
                          <td colSpan="4">Total Variance Order of Equipment </td>

                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat value={grantTotal?.total_estimated_equipment_cost_vo} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                          </td>
                          <td colSpan="1"></td>
                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat value={grantTotal?.total_actual_equipment_cost_vo} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                          </td>
                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat
                              value={grantTotal?.total_equipment_balance_vo}
                              displayType={'text'}
                              thousandSeparator={true}
                              decimalScale={2}
                              fixedDecimalScale={true}
                              style={{
                                marginLeft: '5px',
                                color: grantTotal?.total_equipment_balance_vo < 0 ? '#B42A19' : '',
                              }}
                            />
                          </td>
                        </tr>

                        <tr className="table-borderless" style={{ fontSize: '14px' }}>
                          <td colSpan="4">Total Variance Order of Material </td>

                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat value={grantTotal?.total_estimated_material_cost_vo} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                          </td>

                          <td colSpan="1"></td>
                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat value={grantTotal?.total_actual_material_cost_vo} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                          </td>
                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat
                              value={grantTotal?.total_material_balance_vo}
                              displayType={'text'}
                              thousandSeparator={true}
                              decimalScale={2}
                              fixedDecimalScale={true}
                              style={{
                                marginLeft: '5px',
                                color: grantTotal?.total_material_balance < 0 ? '#B42A19' : '',
                              }}
                            />
                          </td>
                        </tr>

                        <tr style={{ fontSize: '14px' }}>
                          <td colSpan="4">
                            <CTooltip content="Total variance order cost for the project" placement="right-end" color="white">
                              <span>
                                Total Variance Order Cost
                                <FaRegQuestionCircle
                                  style={{
                                    width: '15px',
                                    height: '15px',
                                    marginLeft: '5px',
                                    color: '#757070',
                                  }}
                                />
                              </span>
                            </CTooltip>
                          </td>

                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat value={grantTotal?.estimated_variance_order_cost} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                          </td>
                          <td></td>
                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat value={grantTotal?.actual_variance_order_cost} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                          </td>

                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat
                              value={0}
                              displayType={'text'}
                              thousandSeparator={true}
                              decimalScale={2}
                              fixedDecimalScale={true}
                              style={{
                                marginLeft: '5px',
                                color: grantTotal?.total_variance_order_balance < 0 ? '#B42A19' : '',
                              }}
                            />
                          </td>
                        </tr>

                        {/* START OF SUBCON */}
                        <tr className="table-borderless">
                          <td colSpan="8"></td>
                        </tr>

                        <tr className="table-borderless" style={{ fontSize: '14px' }}>
                          <td colSpan="4">Total Subcontractor  Labor </td>

                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat value={grantTotal?.total_estimate_labor_sub_con} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                          </td>
                          <td colSpan="1"></td>

                          <td colSpan="1" className="d-flex align-items-end justify-content-end">
                            ₱
                            <NumberFormat value={grantTotal?.total_actual_labor_sub_con} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                          </td>

                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat
                              value={grantTotal?.total_labor_balance_subcon}
                              displayType={'text'}
                              thousandSeparator={true}
                              decimalScale={2}
                              fixedDecimalScale={true}
                              style={{
                                marginLeft: '5px',
                                color: grantTotal?.total_labor_balance_subcon < 0 ? '#B42A19' : '',
                              }}
                            />
                          </td>
                        </tr>
                        <tr className="table-borderless" style={{ fontSize: '14px' }}>
                          <td colSpan="4">Total Subcontractor Equipment </td>

                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat value={grantTotal?.total_estimate_equipment_sub_con} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                          </td>
                          <td colSpan="1"></td>
                          <td colSpan="1" className="d-flex align-items-end justify-content-end">
                            ₱
                            <NumberFormat value={grantTotal?.total_actual_equipment_sub_con} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                          </td>
                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat
                              value={grantTotal?.total_equipment_balance_subcon}
                              displayType={'text'}
                              thousandSeparator={true}
                              decimalScale={2}
                              fixedDecimalScale={true}
                              style={{
                                marginLeft: '5px',
                                color: grantTotal?.total_equipment_balance_subcon < 0 ? '#B42A19' : '',
                              }}
                            />
                          </td>
                        </tr>

                        <tr className="table-borderless" style={{ fontSize: '14px' }}>
                          <td colSpan="4">Total Subcontractor Material </td>

                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat value={grantTotal?.total_estimate_material_sub_con} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                          </td>

                          <td colSpan="1"></td>
                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat value={grantTotal?.total_actual_material_sub_con} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                          </td>
                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat
                              value={grantTotal?.total_material_balance_subcon}
                              displayType={'text'}
                              thousandSeparator={true}
                              decimalScale={2}
                              fixedDecimalScale={true}
                              style={{
                                marginLeft: '5px',
                                color: grantTotal?.total_material_balance_subcon < 0 ? '#B42A19' : '',
                              }}
                            />
                          </td>
                        </tr>

                        <tr style={{ fontSize: '14px' }}>
                          <td colSpan="4">
                            <CTooltip content="Total subcontractor cost for the project" placement="right-end" color="white">
                              <span>
                                Total Subcontractor Cost
                                <FaRegQuestionCircle
                                  style={{
                                    width: '15px',
                                    height: '15px',
                                    marginLeft: '5px',
                                    color: '#757070',
                                  }}
                                />
                              </span>
                            </CTooltip>
                          </td>

                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat value={grantTotal?.estimated_sub_con_cost} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                          </td>
                          <td colSpan="1"></td>

                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat value={grantTotal?.actual_sub_con_cost} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                          </td>
                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat
                              value={grantTotal?.total_sub_con_balance}
                              displayType={'text'}
                              thousandSeparator={true}
                              decimalScale={2}
                              fixedDecimalScale={true}
                              style={{
                                marginLeft: '5px',
                                color: grantTotal?.total_sub_con_balance < 0 ? '#B42A19' : '',
                              }}
                            />
                          </td>
                        </tr>
                        <tr className="table-borderless">
                          <td colSpan="8"></td>
                        </tr>

                        {/* END OF SUBCON */}
                        <tr className="table-borderless">
                          <td colSpan="8"></td>
                        </tr>

                        <tr className="table-borderless" style={{ fontSize: '14px' }}>
                          <td colSpan="4">Total Labor </td>

                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat value={grantTotal?.total_estimated_labor_cost} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                          </td>
                          <td colSpan="1"></td>

                          <td colSpan="1" className="d-flex align-items-end justify-content-end">
                            <span className="align-self-center">₱</span>

                            {isLaborGrantTotalEditing ? (
                              <NumberFormat
                                value={grantTotal?.total_actual_labor_cost}
                                thousandSeparator={true}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                customInput={CInput}
                                onValueChange={handleLaborGrantTotalChange}
                                onBlur={handleLaborGrantTotalBlur}
                                autoFocus
                                onKeyDown={preventInvalidKeys}
                                onWheel={blurOnWheel}
                                onPaste={preventInvalidPaste}
                                style={{ marginLeft: '5px', width: '50%' }}
                              />
                            ) : (
                              <>
                                <CTooltip content="Update the total labor actual cost weekly to ensure accuracy." placement="top" role='button'>
                                  <span className="align-self-center" style={{ marginLeft: '5px' }}>
                                    {(grantTotal?.total_actual_labor_cost ?? 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                  </span>
                                </CTooltip>
                                <CTooltip content="Click to edit the total labor actual cost" placement="top">
                                  <FaPencilAlt onClick={toggleLaborGrantTotalEditMode} className="align-self-center" style={{ cursor: 'pointer', marginLeft: '8px' }} />
                                </CTooltip>
                              </>
                            )}
                          </td>

                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat
                              value={grantTotal?.total_labor_balance}
                              displayType={'text'}
                              thousandSeparator={true}
                              decimalScale={2}
                              fixedDecimalScale={true}
                              style={{
                                marginLeft: '5px',
                                color: grantTotal?.total_labor_balance < 0 ? '#B42A19' : '',
                              }}
                            />
                          </td>
                        </tr>
                        <tr className="table-borderless" style={{ fontSize: '14px' }}>
                          <td colSpan="4">Total Equipment </td>

                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat value={grantTotal?.total_estimated_equipment_cost} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                          </td>
                          <td colSpan="1"></td>
                          <td colSpan="1" className="d-flex align-items-end justify-content-end">
                            <span className="align-self-center">₱</span>
                            {isEquipmentGrantTotalEditing ? (
                              <NumberFormat
                                value={grantTotal?.total_actual_equipment_cost}
                                thousandSeparator={true}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                customInput={CInput}
                                onValueChange={handleEquipmentGrantTotalChange}
                                onBlur={handleEquipmentGrantTotalBlur}
                                autoFocus
                                onKeyDown={preventInvalidKeys}
                                onWheel={blurOnWheel}
                                onPaste={preventInvalidPaste}
                                style={{ marginLeft: '5px', width: '50%' }}
                              />
                            ) : (
                              <>
                                <CTooltip content="Update the total equipment actual cost weekly to ensure accuracy." placement="top">
                                  <span className="align-self-center" style={{ marginLeft: '5px' }}>
                                    {(grantTotal?.total_actual_equipment_cost ?? 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                  </span>
                                </CTooltip>
                                <CTooltip content="Click to edit the total equipment actual cost" placement="top">
                                  <FaPencilAlt onClick={toggleEquipmentGrantTotalEditMode} className="align-self-center" style={{ cursor: 'pointer', marginLeft: '8px' }} />
                                </CTooltip>
                              </>
                            )}
                          </td>
                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat
                              value={grantTotal?.total_equipment_balance}
                              displayType={'text'}
                              thousandSeparator={true}
                              decimalScale={2}
                              fixedDecimalScale={true}
                              style={{
                                marginLeft: '5px',
                                color: grantTotal?.total_equipment_balance < 0 ? '#B42A19' : '',
                              }}
                            />
                          </td>
                        </tr>

                        <tr className="table-borderless" style={{ fontSize: '14px' }}>
                          <td colSpan="4">Total Material </td>

                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat value={grantTotal?.total_estimated_material_cost} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                          </td>

                          <td colSpan="1"></td>
                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat value={grantTotal?.total_actual_material_cost} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                          </td>
                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat
                              value={grantTotal?.total_material_balance}
                              displayType={'text'}
                              thousandSeparator={true}
                              decimalScale={2}
                              fixedDecimalScale={true}
                              style={{
                                marginLeft: '5px',
                                color: grantTotal?.total_material_balance < 0 ? '#B42A19' : '',
                              }}
                            />
                          </td>
                        </tr>

                        <tr style={{ fontSize: '14px' }}>
                          <td colSpan="4">
                            <CTooltip content="Total Direct Cost = Total Labor Cost + Total Equipment Cost + Total Material Cost + Total Variance Order Cost" placement="right-end" color="white">
                              <span>
                                Total Direct Cost
                                <FaRegQuestionCircle
                                  style={{
                                    width: '15px',
                                    height: '15px',
                                    marginLeft: '5px',
                                    color: '#757070',
                                  }}
                                />
                              </span>
                            </CTooltip>
                          </td>

                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat value={grantTotal?.estimated_total_direct_cost} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                          </td>
                          <td colSpan="1"></td>

                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat value={grantTotal?.actual_total_direct_cost} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                          </td>
                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat
                              value={grantTotal?.total_direct_cost_balance}
                              displayType={'text'}
                              thousandSeparator={true}
                              decimalScale={2}
                              fixedDecimalScale={true}
                              style={{
                                marginLeft: '5px',
                                color: grantTotal?.total_direct_cost_balance < 0 ? '#B42A19' : '',
                              }}
                            />
                          </td>
                        </tr>
                        <tr className="table-borderless">
                          <td colSpan="8"></td>
                        </tr>

                        <tr className="table-borderless" style={{ fontSize: '14px' }}>
                          <td colSpan="4">
                            <CTooltip content={`Overhead, contingencies, and miscellaneous = ${grantTotal?.ocm_percentage}% of Total Actual Direct Cost`} placement="right-end" color="white">
                              <span>
                                OCM
                                <FaRegQuestionCircle
                                  style={{
                                    width: '15px',
                                    height: '15px',
                                    marginLeft: '5px',
                                    color: '#757070',
                                  }}
                                />
                              </span>
                            </CTooltip>
                          </td>

                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            <NumberFormat value={grantTotal?.estimated_ocm} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                          </td>
                          <td></td>
                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            <NumberFormat value={grantTotal?.actual_ocm} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                          </td>
                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            <NumberFormat
                              value={grantTotal?.ocm_balance}
                              displayType={'text'}
                              thousandSeparator={true}
                              decimalScale={2}
                              fixedDecimalScale={true}
                              style={{
                                marginLeft: '5px',
                                color: grantTotal?.ocm_balance < 0 ? '#B42A19' : '',
                              }}
                            />
                          </td>
                        </tr>

                        {hasVAT != 2 && (
                          <tr className="table-borderless" style={{ fontSize: '14px' }}>
                            <td colSpan="4">
                              <CTooltip content={`Value Added Tax = ${grantTotal?.vat_value ? grantTotal?.vat_value * 100 : 0}% of (Total Actual Direct Cost + OCM + CP)`} placement="right-end" color="white">
                                <span>
                                  VAT
                                  <FaRegQuestionCircle
                                    style={{
                                      width: '15px',
                                      height: '15px',
                                      marginLeft: '5px',
                                      color: '#757070',
                                    }}
                                  />
                                </span>
                              </CTooltip>
                            </td>

                            <td colSpan="1" style={{ textAlign: 'right' }}>
                              <NumberFormat value={grantTotal?.estimated_vat} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                            </td>
                            <td></td>
                            <td colSpan="1" style={{ textAlign: 'right' }}>
                              <NumberFormat value={grantTotal?.actual_vat} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                            </td>

                            <td colSpan="1" style={{ textAlign: 'right' }}>
                              <NumberFormat
                                value={grantTotal?.vat_balance}
                                displayType={'text'}
                                thousandSeparator={true}
                                decimalScale={2}
                                fixedDecimalScale={true}
                                style={{
                                  marginLeft: '5px',
                                  color: grantTotal?.vat_balance < 0 ? '#B42A19' : '',
                                }}
                              />
                            </td>
                          </tr>
                        )}

                        <tr className="table-borderless" style={{ fontSize: '14px' }}>
                          <td colSpan="4">
                            <CTooltip content={`Contractor’s Profit = ${grantTotal?.cp_percenteage}% of Total Actual Direct Cost`} placement="right-end" color="white">
                              <span>
                                CP
                                <FaRegQuestionCircle
                                  style={{
                                    width: '15px',
                                    height: '15px',
                                    marginLeft: '5px',
                                    color: '#757070',
                                  }}
                                />
                              </span>
                            </CTooltip>
                          </td>

                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            <NumberFormat value={grantTotal?.estimated_cp} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                          </td>
                          <td></td>
                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            <NumberFormat value={grantTotal?.actual_cp} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                          </td>

                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            <NumberFormat
                              value={grantTotal?.cp_balance}
                              displayType={'text'}
                              thousandSeparator={true}
                              decimalScale={2}
                              fixedDecimalScale={true}
                              style={{
                                marginLeft: '5px',
                                color: grantTotal?.cp_balance < 0 ? '#B42A19' : '',
                              }}
                            />
                          </td>
                        </tr>

                        <tr style={{ fontSize: '14px' }}>
                          <td colSpan="4">
                            <CTooltip content="Total Indirect Cost = OCM + CP + VAT" placement="right-end" color="white">
                              <span>
                                Total Indirect Cost
                                <FaRegQuestionCircle
                                  style={{
                                    width: '15px',
                                    height: '15px',
                                    marginLeft: '5px',
                                    color: '#757070',
                                  }}
                                />
                              </span>
                            </CTooltip>
                          </td>

                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat value={grantTotal?.estimated_total_indirect_cost} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                          </td>
                          <td></td>
                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat value={grantTotal?.actual_total_indirect_cost} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                          </td>

                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat
                              value={grantTotal?.total_indirect_cost_balance}
                              displayType={'text'}
                              thousandSeparator={true}
                              decimalScale={2}
                              fixedDecimalScale={true}
                              style={{
                                marginLeft: '5px',
                                color: grantTotal?.total_indirect_cost_balance < 0 ? '#B42A19' : '',
                              }}
                            />
                          </td>
                        </tr>

                        <tr className="table-borderless" style={{ fontSize: '14px' }}>
                          <td colSpan="4">
                            <CTooltip content=" Total Contract Cost = Total Actual Direct Cost + Total Indirect Cost" placement="right-end" color="white">
                              <span>
                                Total Contract Cost
                                <FaRegQuestionCircle
                                  style={{
                                    width: '15px',
                                    height: '15px',
                                    marginLeft: '5px',
                                    color: '#757070',
                                  }}
                                />
                              </span>
                            </CTooltip>
                          </td>

                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat value={grantTotal?.estimated_total_contract_cost} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} ode />
                          </td>
                          <td></td>
                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat value={grantTotal?.actual_total_contract_cost} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} style={{ marginLeft: '5px' }} />
                          </td>

                          <td colSpan="1" style={{ textAlign: 'right' }}>
                            ₱
                            <NumberFormat
                              value={grantTotal?.total_contract_cost_balance}
                              displayType={'text'}
                              thousandSeparator={true}
                              decimalScale={2}
                              fixedDecimalScale={true}
                              style={{
                                marginLeft: '5px',
                                color: grantTotal?.total_contract_cost_balance < 0 ? '#B42A19' : '',
                              }}
                            />
                          </td>
                        </tr>

                        <tr className="table-borderless">
                          <td> </td>
                        </tr>
                        <tr className="table-borderless">
                          <td> </td>
                        </tr>
                        <tr>
                          <td
                            colSpan="8"
                            style={{
                              borderBottom: '5px solid #549764',
                              borderTop: '1px solid white',
                            }}
                          ></td>
                        </tr>
                      </tbody>
                    )}
                  </table>
                )}
              </>
            )}
          </div>
          {printEstimate == true && (
            <table className="table" id="my-table">
              <PrintEstimate value={dupadata} />
            </table>
          )}
        </CCol>
      </CRow>
      <CModal show={modalCategory} onClose={() => onCloseCategory()} size="md" style={{ borderRadius: '5px' }} centered>
        <CModalHeader closeButton style={{ borderColor: 'white' }}>
          <CModalTitle>Add New Equipment Category</CModalTitle>
        </CModalHeader>

        <CCol sm="12">
          <CForm action="" method="post">
            <CFormGroup>
              <CLabel>Equipment Category</CLabel>
              <CInput value={category} onChange={(e) => setCategory(e.target.value)} placeholder="Enter Equipment Category.." />
            </CFormGroup>
          </CForm>
        </CCol>

        <CModalFooter style={{ borderColor: 'white' }}>
          <CCol md="4" sm="4" lg="4" xl="4">
            <CButton block variant="outline" color="aimhi-textlight-neutral" size="sm" onClick={() => submitCategory()} disabled={!category}>
              Submit
            </CButton>
          </CCol>
        </CModalFooter>
      </CModal>
      {showEstimateUpload && (
        <EstimateUpload showEstimateUpload={showEstimateUpload} onClose={() => setShowEstimateUpload(false)} project_id={projectID} />
      )}
      <CModal show={modalPosition} onClose={() => onClosePosition()} size="md" style={{ borderRadius: '5px' }} centered>
        <CModalHeader closeButton style={{ borderColor: 'white' }}>
          <CModalTitle>Add New Manpower Position</CModalTitle>
        </CModalHeader>

        <CCol sm="12">
          <CForm action="" method="post">
            <CFormGroup>
              <CLabel>Manpower Position</CLabel>
              <CInput value={position} onChange={(e) => setPosition(e.target.value)} placeholder="Enter Manpower Position.." />
            </CFormGroup>
            <CFormGroup>
              <CLabel>Description</CLabel>
              <CInput value={positionDescription} onChange={(e) => setPositionDescription(e.target.value)} placeholder="Enter Description.." />
            </CFormGroup>
          </CForm>
        </CCol>

        <CModalFooter style={{ borderColor: 'white' }}>
          <CCol md="4" sm="4" lg="4" xl="4">
            <CButton block variant="outline" color="aimhi-textlight-neutral" size="sm" onClick={() => submitPosition()} disabled={!position}>
              Submit
            </CButton>
          </CCol>
        </CModalFooter>
      </CModal>
      <CModal show={modalVarianceOrder} onClose={() => setModalVarianceOrder(!modalVarianceOrder)} size="xl" style={{ borderRadius: '5px' }} centered>
        <CModalHeader closeButton style={{ borderColor: 'white' }}>
          {varianceOrderData.length > 1 ? (
            <>
              <CModalTitle style={{ fontSize: '28px', paddingLeft: '20px', paddingTop: '20px', paddingBottom: '0px' }}>
                Are these variance orders? <h6 style={{ fontStyle: 'italic' }}> Check the checkbox next to the scope of work if it's a variance order.</h6>
              </CModalTitle>
            </>
          ) : (
            <CModalTitle style={{ fontSize: '28px', paddingLeft: '20px', paddingTop: '20px', paddingBottom: '0px' }}>Is this a variance order?</CModalTitle>
          )}
        </CModalHeader>

        <CCol sm="12" style={{ padding: '20px', maxHeight: '600px', overflow: 'auto' }}>
          <table className="table">{varianceOrderPreview}</table>
        </CCol>

        <CModalFooter style={{ borderColor: 'white', display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}>
          <CCol md="8" sm="8" lg="8" xl="8">
            {varianceOrderData.length > 1 ? (
              <CRow style={{ width: '100%', justifyContent: 'flex-end' }}>
                <CButton
                  style={{ width: '20%' }}
                  size="md"
                  color="aimhi-textlight-neutral"
                  variant="outline"
                  onClick={() => varianceOrderSubmit()}
                >
                  Submit
                </CButton>
              </CRow>
            ) : (
              <CRow style={{ width: '100%', justifyContent: 'flex-end' }}>
                <CButton style={{ marginRight: '20px', width: '20%' }} size="md" variant="outline" color="aimhi-textlight-neutral" onClick={() => varianceOrderYes()}>
                  Yes
                </CButton>
                <CButton style={{ width: '20%' }} size="md" variant="outline" color="aimhi-textlight-neutral" onClick={() => varianceOrderNo()}>
                  No
                </CButton>
              </CRow>
            )}
          </CCol>
        </CModalFooter>
      </CModal>
    </>
  );
};

export default ProjectBudgetDetail;
